import debounce from 'lodash.debounce';
import React, { useState, useEffect, useRef } from "react";
import Countdown from 'react-countdown';
import OwlCarousel from 'react-owl-carousel3';
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/all.css";
import "../assets/css/style.css";
import "../assets/css/responsive.css";
import "../assets/css/flipdown.css";
import apiPath from "../constants/apiPath";
import Http from "../services/Http";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import toast, { Toaster } from "react-hot-toast";
import Product from "../view/Component/ProductSearch"
import Login from '../view/Modal/Login';
import Banner from "../view/Component/Banner"
import ShowSignBox from "../view/Modal/ShowSignBox";
import {
	Container,
	Form,
	Nav,
	Navbar,
	NavDropdown,
	Offcanvas,
	Button,
	Row,
	Col,
} from "react-bootstrap";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { internalIpV6, internalIpV4 } from "../services/getIp";
import h1Image from "../assets/img/h-1.png";
import h2Image from "../assets/img/h-2.png";
import h3Image from "../assets/img/h-3.png";
import logo from "../assets/img/logo.webp";
import search from "../assets/img/search.png";
import closeImg from "../assets/img/close.png";
import appstore from "../assets/img/app-store.png";
import googleplay from "../assets/img/google-play.png";
import appgallery from "../assets/img/app-gallery.png";
import offerBadge from "../assets/img/offer-badge.svg";
import mikeSvg from "../assets/img/mic.png";
import MenuArrow from "../assets/img/arrow-down.png";
import { userLogin } from "../actions/index";
import { connect } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import Currency from "../view/Component/Currency";
import {
	SelectGroup,
	TextInput,
	ValidationForm,
} from "react-bootstrap4-form-validation";
import Imgcross from '../assets/img/cross.png';
import Modal from "react-bootstrap/Modal";
import { useParams } from 'react-router-dom';
import LocalizedStrings from "react-localization";
import localization from "../localization";
import Dictaphone from "../view/Modal/Dictaphone";
import axios from 'axios'
import { CART_DRAWER_UPDATED, openCartDrawer } from "../services/cartDrawerEvents";
let strings = new LocalizedStrings(localization);

const AI_SEARCH_ENABLED = true;

const mapStateToProps = (state) => {
	return { user: state.user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		userLogin: (user) => dispatch(userLogin(user)),
	};
};
const newAriveOption = {
	margin: 8,
	nav: true,
	dots: false,
	loop: false,
	rewind: true,
	responsive: {
		0: {
			items: 2,
			margin: 6
		},
		420: {
			items: 2,
			margin: 6
		},
		577: {
			items: 3,
			margin: 6
		},
		767.98: {
			items: 4,
			margin: 8
		},
		992: {
			items: 5,
			margin: 8
		},
		1366: {
			items: 5,
			margin: 8
		},
		1466: {
			items: 5,
			margin: 8
		}
	}
}

const notificationOptions = {
	margin: 0,
	autoplay: true,
	autoplayTimeout: 5000,
	autoplayHoverPause: true,
	nav: false,
	dots: false,
	loop: true,
	rewind: false,
	center: false,
	items: 1
}

const Header = (Props) => {
	const location = useLocation();
	const formRef = React.createRef();
	const [setting, setSetting] = useState([]);
	const [product, setProduct] = useState([]);
	const [country, setCountry] = useState([]);
	const [searchValue, setSearchValue] = useState(Props.searchStatus ? Props.searchStatus : false)
	const [gtIp, setIP] = useState();
	const [currentCurrency, setCurrentCurrency] = useState(
		localStorage.getItem("current_currency")
			? JSON.parse(localStorage.getItem("current_currency"))
			: { currency: 1, country_code: "KWD" }
	);
	const [currentLang, setCurrentLang] = useState(
		localStorage.getItem("current_lang")
			? localStorage.getItem("current_lang")
			: "en"
	);
	if (currentLang == 'ar') {
		import("../assets/css/rtl_style.css");
	}

	const [popupBanners, setPopupBanners] = useState([]);
	const [activePopup, setActivePopup] = useState(null);

	// ── Local autocomplete suggestions (zero AI cost) ──
	const [suggestions, setSuggestions] = useState([]);
	const [showSuggestions, setShowSuggestions] = useState(false);

	const [showSignBoxModal, setShowSignBoxModal] = useState(false);
	const [showLoginModal, setShowLoginModal] = useState(false);

	useEffect(() => {
		if (showSignBoxModal === false && showLoginModal === true) {
			setTimeout(() => setShowLoginModal(true), 10);
		}
	}, [showSignBoxModal, showLoginModal]);

	const handleShowSignBox = () => {
		setShowSignBoxModal(true);
	};

	const handleOpenLogin = () => {
		setShowSignBoxModal(false);
		setShowLoginModal(true);
	};

	const handleCloseLogin = () => {
		setShowLoginModal(false);
	};

	const [comman, setComman] = useState({
		search: null,
		loginModel: false,
		isGuestApply: true,
		cartCount: 0,
		wishListCount: 0,
		latestDiscount: "",
		sale_start_date: 0,
		CurrentDateTime: 0,
		startMike: "start"
	});

	const [searchText, setSearchText] = useState(Props.searchQuery ? decodeURIComponent(Props.searchQuery) : '')
	const [searchLoading, setSearchLoading] = useState(false)
	const [dropdownOpen, setDropdownOpen] = useState(false)
	// AI Suggest mode — always OFF by default on every page load
	const [aiMode, setAiMode] = useState(false);

	const toggleAiMode = () => {
		setAiMode(prev => !prev);
	};
	const handleCartIconClick = (e) => {
		e.preventDefault();
		openCartDrawer();
	};
	// Tracks the query whose results are currently displayed — used to distinguish
	// "press Enter again on the same query" (navigate) from "typed new text + Enter" (re-search).
	const [lastSearchedQuery, setLastSearchedQuery] = useState('')

	let {
		transcript,
		listening,
		resetTranscript,
		browserSupportsSpeechRecognition
	} = useSpeechRecognition();

	if (!browserSupportsSpeechRecognition) {
	}
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const setModalIsOpenToTrue = () => {
		setModalIsOpen(true)
	}
	const setModalIsOpenToFalse = () => {
		setModalIsOpen(false)
	}


	const [user, setUser] = useState(Props.user && typeof Props.user === 'object' && Object.keys(Props.user).length > 0 ? Props.user : null);

	// Stable boolean identity for the login state. Used as the init-effect
	// dependency so guestUser()/getCommon() fire on mount + login change only —
	// depending on the whole `Props` object re-fired them on every parent render
	// (the guest-user / set-preference / ipify ×3 duplication).
	const hasLoggedInUser = !!(Props.user && typeof Props.user === 'object' && Object.keys(Props.user).length > 0);

	const searchBox = (e) => {
		const inputValue = e.target.value;
		setSearchText(inputValue);

		if (inputValue.trim().length > 0) {
			// Only fetch lightweight local suggestions while typing — no AI call
			debouncedSuggestRef.current(inputValue.trim());
		} else {
			setSuggestions([]);
			setShowSuggestions(false);
			document.body.classList.remove("search_area");
		}
	};

	const searchBoxRef = useRef(null);

	// ── Fast local autocomplete (150ms debounce, pure MySQL, no AI) ──
	const fetchSuggestions = async (q) => {
		if (q.length < 2) {
			setSuggestions([]);
			setShowSuggestions(false);
			return;
		}
		try {
			const lang = localStorage.getItem('current_lang') || 'en';
			let result = await Http(apiPath.searchSuggest, {
				method: 'GET',
				params: { q, lang, limit: 8 },
			});
			if (result.status === 200 && result.data && result.data.suggestions) {
				setSuggestions(result.data.suggestions);
				setShowSuggestions(true);
			}
		} catch (e) {
			// Autocomplete is non-critical — never break the UX
		}
	};
	const debouncedSuggestRef = useRef(debounce((q) => fetchSuggestions(q), 150));

	// Trigger the full AI/EXACT search — called on Enter or search icon click
	const triggerFullSearch = (overrideText) => {
		const q = (overrideText ?? searchText).trim();
		if (q.length === 0) return;
		setSuggestions([]);
		setShowSuggestions(false);
		setDropdownOpen(true);
		setSearchLoading(true);
		document.body.classList.add("search_area");
		fetchProducts(q);
	};

	const handleSuggestionClick = (suggestion) => {
		const q = suggestion.text.trim();
		setSearchText(q);
		triggerFullSearch(q);
	};

	const viewAllSearch = (e) => {
		if (e.key !== 'Enter' || searchText.trim().length === 0) return;

		// Dropdown is open and showing results for the SAME query → navigate to full results page
		if (dropdownOpen && product.data && !searchLoading && searchText.trim() === lastSearchedQuery) {
			window.location.href = '/search/' + encodeURIComponent(searchText.trim());
			return;
		}

		// No results yet, or user typed a different query → trigger fresh search in dropdown
		triggerFullSearch();
	};

	// const searchValue =()

	useEffect(() => {
		return () => {
			shortDebounceRef.current.cancel();
			longDebounceRef.current.cancel();
			debouncedSuggestRef.current.cancel();
		};
	}, []);


	useEffect(() => {
		setSearchText(transcript)
	}, [transcript])

	useEffect(() => {
		const currentPath = location.pathname;
		if (currentPath.startsWith('/product/')) {
			setSearchText('');
		}
	}, [location]);

	const getIP = () => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: 'https://api.ipify.org/?format=json',
			headers: {}
		};

		axios.request(config)
			.then(async (response) => {
				await setIP((response.data.ip));
			})
			.catch((error) => {
				console.log(error);
			});

	}
	const guestUser = async () => {

		if (typeof Props.user === 'object' && Object.keys(Props.user).length < 1) {
			let path = apiPath.guestUser;
			var data = new FormData();
			data.append("country_id", "91");
			data.append("language", "en");
			data.append("device_type", "Website");
			data.append("device_token", await internalIpV4());
			let options = {
				method: "POST",
				data: data,
			};

			let result = await Http(path, options);
			if (result.status === 200) {
				if (result.data) {
					Props.userLogin(result.data.data);
					if (result.data.data.details.preferred_country == null && result.data.data.details.preferred_country == null) {
						await setDefaultPreferences();

					}
					getCommon();
				} else {
					toast.error(result.data.message);
				}
			} else {
				if (result.statusText != null) {
					toast.error(result?.data?.message || result.statusText);
				}
			}
		} else {

			if (Props.user.details.preferred_country == null && Props.user.details.preferred_country == null) {
				await setDefaultPreferences();
			}
			getCommon();
		}
	};
	const removeClass = () => {
		document.getElementsByTagName('body')[0].setAttribute("class", '');
	}

	const pendingRequestRef = useRef(null);

	const fetchProducts = async (search) => {
		if (search.length < 3) return;

		// Skip an exact-duplicate request that is still in flight — stops the
		// same query (and, in AI mode, Claude) being hit twice per search.
		const prev = pendingRequestRef.current;
		if (prev && !prev.done && !prev.cancelled && prev.query === search) return;

		setSearchLoading(true);

		// Cancel any pending (different) request — only the latest fires
		if (prev && !prev.done) {
			prev.cancelled = true;
		}
		const thisRequest = { cancelled: false, done: false, query: search };
		pendingRequestRef.current = thisRequest;

		try {
			// AI_SEARCH_ENABLED=false → send disable_ai=1 so the backend skips all AI routing
			const params = AI_SEARCH_ENABLED
				? { search, ...(aiMode ? { force_ai: 1 } : {}) }
				: { search, disable_ai: 1 };

			let result = await Http(apiPath.advanceSearch, {
				method: "GET",
				params,
			});
			// If a newer keystroke has fired, discard this stale result
			if (thisRequest.cancelled) return;

			if (result.status === 200 && result.status) {
				if (search.length > 0) {
					document.body.classList.add("search_area");
					setProduct({ data: result.data.data });
					setLastSearchedQuery(search.trim());
				} else {
					setProduct([]);
					setLastSearchedQuery('');
					document.body.classList.remove("search_area");
				}
			} else {
				toast.error(result.data?.message || result.statusText);
			}
		} catch (e) {
			if (thisRequest.cancelled) return;
			// Network / validation failure (empty, whitespace-only or over-long
			// query, dropped connection) → render a clean empty state instead of
			// leaving the UI on a raw "Failed to fetch".
			setProduct({
				data: {
					top_brand: [],
					current_product: { data: [], pagination: { total: 0, per_page: 10, current_page: 1, last_page: 1, from: null, to: null } },
					recent_search: { data: [], pagination: null },
					also_likes: [],
					ai_explanation: null,
					ai_powered: false,
					search_intent: 'exact',
					corrected_query: null,
				},
			});
			setLastSearchedQuery(search.trim());
		} finally {
			thisRequest.done = true;
			if (!thisRequest.cancelled) {
				setSearchLoading(false);
				// Hide suggestions once full results are loaded
				setShowSuggestions(false);
			}
		}
	};

	// Short debounce for ≤ 2 words (brand / product name lookup).
	// Longer debounce for sentences (AI queries) — gives user time to finish typing.
	const shortDebounceRef = useRef(debounce((search) => fetchProducts(search), 350));
	const longDebounceRef  = useRef(debounce((search) => fetchProducts(search), 800));

	const debouncedGetProduct = (page, search) => {
		const wordCount = search.trim().split(/\s+/).length;
		shortDebounceRef.current.cancel();
		longDebounceRef.current.cancel();
		if (wordCount <= 2) {
			shortDebounceRef.current(search);
		} else {
			longDebounceRef.current(search);
		}
	};

	const getSetting = async () => {
		let path = apiPath.setting;
		var data = new FormData();
		let options = {
			method: "GET",
		};
		let result = await Http(path, options);
		if (result.status == 200) {
			if (result.data.status == true) {
				setSetting({ data: result.data.data });
			} else {
				toast.error(result.data.message);
			}
		} else {
			if (result.statusText != null) {
				toast.error(result?.data?.message || result.statusText);
			}
		}
	};

	const normalizePath = (url) => {
		if (!url) return "/";

		try {
			const parsed = new URL(url, window.location.origin);
			let path = parsed.pathname;

			path = path.replace(/\/+$/, "");
			return path === "" ? "/" : path;

		} catch {
			const clean = url.split("?")[0].replace(/\/+$/, "");
			return clean === "" ? "/" : clean;
		}
	};

	const shouldShowPopup = (popup, currentPath) => {
		try {
			const now = Date.now();

			// Time check (optional safety)
			if (popup.active_from && now < new Date(popup.active_from).getTime()) {
				return false;
			}

			if (popup.expire_at && now > new Date(popup.expire_at).getTime()) {
				return false;
			}

			// Route check
			if (popup.show_pages && popup.show_pages.length > 0) {
				const match = popup.show_pages.some((p) =>
					normalizePath(p) === currentPath
				);

				if (!match) return false;
			}

			// LocalStorage anti spam
			const storageKey = `popup_seen_${popup.id}`;
			const stored = localStorage.getItem(storageKey);

			if (stored) {
				const parsed = JSON.parse(stored);

				if (parsed.expireAt && now < parsed.expireAt) {
					return false;
				}
			}

			return true;

		} catch (e) {
			return false;
		}
	};

	const getCommon = async () => {
		let path = apiPath.commonApi;
		var data = new FormData();
		let options = {
			method: "GET",
		};
		let result = await Http(path, options);
		if (result.status == 200) {
			if (result.data.status == true) {
				await setComman({
					cartCount: result.data.data.cart_count,
					wishListCount: result.data.data.wishlist_count,
					latestDiscount: result.data.data.latest_discount,
					sale_start_date: (new Date(result.data.data.admin_setting.sale_start_date).getTime() - new Date(result.data.data.admin_setting.current_date).getTime()),
					CurrentDateTime: new Date(result.data.data.admin_setting.current_date).getTime(),
					homepageDiscountText: result.data.data.admin_setting.homepage_discount_text,
				});

				const currentPath = normalizePath(location.pathname);

				const filteredPopups = (result.data.data.popup_banner || []).filter(p =>
					shouldShowPopup(p, currentPath)
				);
				setPopupBanners(filteredPopups);
			} else {
				Props.userLogin({});
				window.location.assign('/');
			}
		} else {
			if (result.statusText != null) {
				toast.error(result?.data?.message || result.statusText);
			}
		}
	};

	useEffect(() => {
		if (!popupBanners.length) return;

		const currentPath = normalizePath(location.pathname);

		const matchedPopup = popupBanners.find((p) => {
			if (!p.show_pages || p.show_pages.length === 0) return true;

			return p.show_pages.some((u) => normalizePath(u) === currentPath);
		});

		if (!matchedPopup) return;

		const storageKey = `popup_seen_${matchedPopup.id}`;
		const stored = localStorage.getItem(storageKey);

		if (stored) {
			const parsed = JSON.parse(stored);
			if (parsed.expireAt && Date.now() < parsed.expireAt) return;
		}

		setActivePopup(matchedPopup);
	}, [popupBanners, location.pathname]);

	const closePopup = (popupId) => {
		// const sixHours = 6 * 60 * 60 * 1000;
		const sixHours = 0;

		localStorage.setItem(
			`popup_seen_${popupId}`,
			JSON.stringify({
				expireAt: Date.now() + sixHours
			})
		);

		setPopupBanners([]);
		setActivePopup(null);
	};

	const handleLogout = async () => {
		if (window.confirm(strings.are_you_sure_logout) == true) {
			let path = apiPath.logout;
			var data = new FormData();
			data.append("country_id", "91");
			data.append("language", "en");
			data.append("device_type", "Website");
			data.append("device_token", await internalIpV4());
			let options = {
				method: "POST",

				data: data,
			};

			let result = await Http(path, options);
			if (result.status === 200) {
				if (result.data) {
					Props.userLogin({});
					toast.success(result.data.message);
					window.location.assign('/');
				} else {
					toast.error(result.data.message);
				}
			} else {
				if (result.statusText != null) {
					toast.error(result?.data?.message || result.statusText);
				}
			}
		}
	};

	const [isScrolled, setIsScrolled] = useState(false);

	// Notify-me modal (search results)
	const [notifyMeModal, setNotifyMeModal] = useState(false);
	const [notifyMeItem, setNotifyMeItem] = useState(null);
	const [notifyMeName, setNotifyMeName] = useState('');
	const [notifyMePhone, setNotifyMePhone] = useState('');


	useEffect(() => {
		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	const addToCartFromSearch = async (e, item) => {
		e.preventDefault();
		e.stopPropagation();
		try {
			const data = new FormData();
			data.append('product_id', item.id);
			data.append('qty', 1);
			data.append('is_increment', 1);
			const result = await Http(apiPath.AddtoCart, { method: 'POST', data });
			if (result.status === 200 && result.data.status) {
				toast.success(result.data.message || 'Added to cart');
				setComman(prev => ({ ...prev, cartCount: result.data.data?.cart_count ?? prev.cartCount }));
			} else {
				toast.error(result.data?.message || 'Could not add to cart');
			}
		} catch {
			toast.error('Could not add to cart');
		}
	};

	const showNotifyMeFromSearch = (e, item) => {
		e.preventDefault();
		e.stopPropagation();
		setNotifyMeItem(item);
		setNotifyMeName('');
		setNotifyMePhone('');
		setNotifyMeModal(true);
	};

	const submitNotifyMe = async () => {
		if (!notifyMeItem) return;
		try {
			const data = new FormData();
			data.append('name', notifyMeName);
			data.append('phone', notifyMePhone);
			const result = await Http(apiPath.notifyMe + '/' + notifyMeItem.id, { method: 'POST', data });
			if (result.status === 200 && result.data.status) {
				toast.success(result.data.message);
			} else {
				toast.error(result.data?.message || 'Could not submit');
			}
		} catch {
			toast.error('Could not submit');
		}
		setNotifyMeModal(false);
	};

	const handleScroll = () => {
		const scrollY = window.scrollY;
		if (scrollY >= 100) {
			setIsScrolled(true);
		} else {
			setIsScrolled(false);
		}
	};
	const getCountry = async () => {
		let path = apiPath.getCountry;
		var data = new FormData();
		let options = {
			method: "POST",
		};
		let result = await Http(path, options);
		if (result.status === 200) {
			if (result.data) {
				let resultJson = result.data.result;
				await setCountry({
					data: result.data.data,
				});
			} else {
				toast.error(result.data.message);
			}
		} else {
			if (result.statusText != null) {
				toast.error(result?.data?.message || result.statusText);
			}
		}
	};

	const changeCurrency = (e) => {
		var index = e.nativeEvent.target.selectedIndex;
		const current_currency = {
			currency: e.target.value,
			country_code: e.nativeEvent.target[index].text,
		};
		setCurrentCurrency(current_currency);
		localStorage.setItem(
			"current_currency",
			JSON.stringify(current_currency)
		);
		window.location.reload();
	};

	const setDefaultPreferences = async () => {
		let path = apiPath.setPreference;
		let formData = {
			preferred_country: "Kuwait",
			preferred_language: "en"
		};

		let options = {
			method: 'POST',
			data: formData
		};

		try {
			if (Object.keys(Props.user).length > 0) {
				let result = await Http(path, options);
				if (result.status === 200) {
					if (result.data.status) {
						Props.user.details.preferred_country = result.data.data.preferred_country;
						Props.user.details.preferred_language = result.data.data.preferred_language;
						Props.userLogin(Props.user);
					} else {
						console.log(result.data.message);
					}
				} else {
					throw new Error(result.statusText);
				}
			}
		} catch (error) {
			console.log("Error: " + error.message);
		}
	};

	const setPreference = async (e, formData, inputs) => {
		e.preventDefault();
		let path = apiPath.setPreference;
		let options = {
			method: 'POST',
			data: formData
		}
		let result = await Http(path, options);
		if (result.status === 200) {
			if (result.data.status) {
				Props.user.details.preferred_country = result.data.data.preferred_country
				Props.user.details.preferred_language = result.data.data.preferred_language
				Props.userLogin(Props.user)
				setModalIsOpen(false);

			} else {
				toast.error(result.data.message);
			}
		} else {
			if (result.statusText != null) {
				toast.error(result?.data?.message || result.statusText);
			}
		}
	}
	const setPreferenceErrorSubmit = (e, formData, inputs) => {
		e.preventDefault();
	}
	const SpeechMike = async (e, type) => {
		if (type == "start") {
			SpeechRecognition.startListening();
			await setComman({ ...comman, search: transcript })
			setSearchText(transcript)
		}
	}
	const changeLanguage = (e) => {
		setCurrentLang(e.target.value);
		localStorage.setItem("current_lang", e.target.value);
		window.location.reload();
	};

	const renderer = ({ days, hours, minutes, seconds, completed }) => {
		var days1 = (days < 10 ? '0' + days : days).toString().split("");
		var hours1 = (hours < 10 ? '0' + hours : hours).toString().split("");
		var minutes1 = (minutes < 10 ? '0' + minutes : minutes).toString().split("");
		var seconds1 = (seconds < 10 ? '0' + seconds : seconds).toString().split("");

		return (
			<>

				<div className="timer_count_bg"><span>{days1[0]}</span><span>{days1[1]}</span></div>:
				<div className="timer_count_bg"><span>{hours1[0]}</span><span>{hours1[1]}</span></div>:
				<div className="timer_count_bg"><span>{minutes1[0]}</span><span>{minutes1[1]}</span></div>:
				<div className="timer_count_bg"><span>{seconds1[0]}</span><span>{seconds1[1]}</span></div>

			</>
		)
	}

	strings.setLanguage(currentLang);
	const addClass = (e, type) => {
		document.getElementsByTagName('body')[0].setAttribute("class", 'open_menu');
	}

	useEffect(() => {
		setComman({ ...comman, loginModel: false });
		getSetting();
		getCountry();
	}, []);
	// Client IP — needed once per mount.
	useEffect(() => {
		getIP();
	}, []);

	// (Re)initialise the guest/logged-in user + common data only when the login
	// state actually flips, not on every unrelated Props reference change.
	useEffect(() => {
		guestUser();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasLoggedInUser]);
	useEffect(() => {
		const handleCartUpdated = () => {
			getCommon();
		};

		window.addEventListener(CART_DRAWER_UPDATED, handleCartUpdated);

		return () => {
			window.removeEventListener(CART_DRAWER_UPDATED, handleCartUpdated);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	useEffect(() => {
		setSearchValue(Props.searchStatus ? Props.searchStatus : false)
	}, [Props.searchStatus]);

	useEffect(() => {
		setSearchText(Props.searchQuery ? decodeURIComponent(Props.searchQuery) : '');
		setProduct([]);
		setDropdownOpen(false);
		setSuggestions([]);
		setShowSuggestions(false);
	}, [location.pathname, location.search, Props.searchQuery]);

	return (
		<>
			{showSignBoxModal && (
				<ShowSignBox
					onLoginClicked={handleOpenLogin}
				/>
			)}
			{showLoginModal && (
				<Login data={showLoginModal}
					onClose={handleCloseLogin}
				/>
			)}
			{/* {
				searchValue ? <Navigate to={`/search/${searchText}`} /> : null
			} */}
			<div className="tosterOuter"><Toaster position="top-right"></Toaster></div>
			<header className="header_sec" >
				<div className="top_header">
					<div className="container">
						<div className="head_top_cont">
							{setting.data ?
								<OwlCarousel className="owl-carousel owl-theme" {...notificationOptions}  >
									{setting.data.announcements.map((item, index) =>
										<Link to="#">{item}</Link>
									)}
								</OwlCarousel>
								: <Link to="#">{strings.getAmazingDeals}</Link>}
						</div>
						<div className="header_right">
							<div className="header_contact_info">
								<div className="header_list">
									<Link to="/download">
										<span className="head_icon">
											<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="7" y="2" width="10" height="20" rx="2.5"/><line x1="11" y1="18" x2="13" y2="18"/></svg>
										</span>
										<span>{strings.appDownload}</span>
									</Link>
								</div>
								{/*<div className="header_list">
									<Link to="/gift-card">
										<span className="head_icon">
											<img src={h2Image} alt="Gift Card " />
										</span>
										<span>Gift Card</span>
									</Link>
								</div>*/}

								<div className="header_list">
									<a href="/help">
										<span className="head_icon">
											<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 2.5-3 4"/><line x1="12" y1="17.5" x2="12.01" y2="17.5"/></svg>
										</span>
										<span>{strings.help}</span>
									</a>
								</div>
							</div>
							<div className="header_login_cls">
								<div className="lang-switch" role="group" aria-label="Language">
									<button type="button" className={currentLang == "en" ? "active" : ""} onClick={() => changeLanguage({ target: { value: "en" } })}>EN</button>
									<button type="button" className={currentLang == "ar" ? "active" : ""} onClick={() => changeLanguage({ target: { value: "ar" } })}>ع</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className={`fixedHeader ${isScrolled ? `fixed_header` : ''}`}>
					<div className="middle_header">
						<div className="container">
							<div className="logo-block">
								<div className="logo">
									<Link to="/">
										{setting.data?.image && (
											<img
												src={setting.data.image}
												alt="Logo"
											/>
										)}
									</Link>
								</div>
							</div>
							<div className="menu-right">
								<div className="search-wrap">
									<div className="form-group" style={{ position: `relative` }} ref={searchBoxRef}>
										<div className="input-group">

											{/* Left — search icon */}
											<div className="search-icon">
												<img src={search} alt="Search" onClick={() => triggerFullSearch()} />
											</div>

											<input
												type="text"
												name="search"
												value={searchText}
												className="form-control"
												placeholder="Search perfumes, brands, moods..."
												onChange={searchBox}
												onKeyDown={viewAllSearch}
												onFocus={() => document.body.classList.add("search-active")}
												onBlur={(e) => {
													// Keep the action buttons shown while focus stays inside the
													// search box (e.g. clicking AI Suggest / Search); hide them
													// once focus leaves it entirely. (Mobile shows the buttons
													// only while the search is active.)
													if (!searchBoxRef.current || !searchBoxRef.current.contains(e.relatedTarget)) {
														document.body.classList.remove("search-active");
													}
												}}
											/>

											{/* Right — clear · divider · mic · divider · AI Mode (all inside the pill) */}
											<div className="mike_sec">
												<div className="mike-inner">
													{searchText ? (
														<>
															<button
																onMouseDown={(e) => e.preventDefault()}
																onClick={() => {
																	setSearchText('');
																	setSuggestions([]);
																	setShowSuggestions(false);
																	setDropdownOpen(false);
																	setSearchLoading(false);
																	document.body.classList.remove("search_area");
																}}
																className="btn btn_cross_inner"
																title="Clear"
															>
																<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
																	<line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
																</svg>
															</button>
															<span className="mike-divider" />
														</>
													) : null}
													{/* AI Suggest toggle + Search button */}
													{AI_SEARCH_ENABLED && (
														<>
															<span className="mike-divider" />
															<button
																className={`ai-mode-btn${aiMode ? ' ai-mode-btn--active' : ''}`}
																onMouseDown={(e) => e.preventDefault()}
																onClick={toggleAiMode}
																aria-label={strings.ai_suggest || 'AI Suggest'}
																aria-pressed={aiMode}
																title={aiMode ? 'AI Suggest ON — click to disable' : 'Enable AI Suggest'}
															>
																<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle'}}>
																	<path d="M12 3l1.912 5.813a2 2 0 001.272 1.272L21 12l-5.816 1.916a2 2 0 00-1.272 1.272L12 21l-1.916-5.816A2 2 0 008.812 13.9L3 12l5.813-1.912A2 2 0 0010.1 8.812z"/>
																</svg>
																<span style={{marginLeft: '4px'}}>{strings.ai_suggest || 'AI Suggest'}</span>
															</button>
															<button
																className="search-submit-btn"
																onMouseDown={(e) => e.preventDefault()}
																onClick={() => triggerFullSearch()}
																title="Search"
															>
																Search
															</button>
														</>
													)}
												</div>
											</div>
										</div>

										{/* ── Instant autocomplete suggestions (zero AI cost) ── */}
										{showSuggestions && suggestions.length > 0 && (
											<div className="search-suggestions-dropdown">
												{suggestions.map((s, i) => (
													<div
														key={i}
														className={`search-suggestion-item search-suggestion-type--${s.type}`}
														onMouseDown={(e) => e.preventDefault()}
														onClick={() => handleSuggestionClick(s)}
													>
														<span className="search-suggestion-icon">
															{s.type === 'brand' ? '🏷' : s.type === 'product' ? '🧴' : s.type === 'curated' ? '✨' : '🔍'}
														</span>
														<span className="search-suggestion-text">{s.text}</span>
														<span className="search-suggestion-type">{s.type}</span>
													</div>
												))}
											</div>
										)}

										<div className={(dropdownOpen && searchText && !showSuggestions) ? `search_dropdown_cls${product.data && !(AI_SEARCH_ENABLED && product.data.ai_powered) ? ' search_dropdown_cls--exact' : ''}` : "search_dropdown_cls d-none"}>
											{searchLoading ? (
												<div className="search-ai-loading">
													<div className="search-ai-loading-icon">&#10024;</div>
													<div className="search-ai-loading-text">
														<span>{AI_SEARCH_ENABLED ? 'AI is thinking' : 'Searching...'}</span>
														<span className="search-ai-dots">
															<span></span>
															<span></span>
															<span></span>
														</span>
													</div>
													<div className="search-ai-shimmer-lines">
														<div className="shimmer-line shimmer-line--wide"></div>
														<div className="shimmer-line shimmer-line--medium"></div>
														<div className="shimmer-line shimmer-line--narrow"></div>
													</div>
												</div>
											) : product.data ?
												<>
													{/* ── AI banner — full width at top ── */}
													{AI_SEARCH_ENABLED && product.data.ai_powered && product.data.ai_explanation && (
														<div className="ai-explanation-banner">
															<div className="ai-icon">&#10024;</div>
															<div className="ai-explanation-content">
																<div style={{ marginBottom: 4 }}>
																	<span className="ai-powered-badge">
																		<span className="sparkle">&#10024;</span> {strings.ai_powered_results}
																	</span>
																</div>
																<p>{product.data.ai_explanation}</p>
															</div>
														</div>
													)}

													{/* ── Columns: 3-col for AI, single-col for exact ── */}
													<div className={`row g-0 search-dropdown-cols${!(AI_SEARCH_ENABLED && product.data.ai_powered) ? ' search-dropdown-cols--exact' : ''}`}>
														{/* Col 1 — Products + Also Likes */}
														<div className={AI_SEARCH_ENABLED && product.data.ai_powered ? "col-lg-7 col-12 search-col-products" : "col-12 search-col-products"}>
															<div className="d-flex justify-content-between mb-3 align-items-center">
																<p className="title-search">{strings.products} ({product.data.current_product.pagination.total})</p>
																<a href={"/search/" + encodeURIComponent(searchText)}>{strings.view_all} ({product.data.current_product.pagination.total})</a>
															</div>
															{product.data.current_product.data.length > 0
																? <Product data={product.data.current_product.data} options={newAriveOption} showAddtoCart={addToCartFromSearch} showNotifyMe={showNotifyMeFromSearch} />
																: ''}
															{AI_SEARCH_ENABLED && product.data.also_likes && product.data.also_likes.length > 0 && (() => {
																const seen = new Set();
																const combined = product.data.also_likes
																	.flatMap(entry => entry.similar_products || [])
																	.filter(p => { if (seen.has(p.id)) return false; seen.add(p.id); return true; });
																return combined.length > 0 ? (
																	<div className="also-likes-section" style={{ marginTop: 14, paddingTop: 14 }}>
																		<div className="section-heading">
																			<h3>{strings.similar_perfumes}</h3>
																		</div>
																		<Product data={combined} options={newAriveOption} showAddtoCart={addToCartFromSearch} showNotifyMe={showNotifyMeFromSearch} />
																	</div>
																) : null;
															})()}
														</div>

														{/* Col 2 — Top Brands card */}
														<div className={AI_SEARCH_ENABLED && product.data.ai_powered ? "col-lg-3 col-12 search-col-card search-col-brands" : "col-12 search-col-card search-col-brands"}>
															<p className="title-search">{strings.top_brands}</p>
															<div className="search-card-items search-brand-grid">
																{product.data.top_brand.length > 0
																	? product.data.top_brand.map((item, index) => (
																		<Link key={index} className="search-brand-card" to={'/brand/' + item.slug}>
																			<div className="search-brand-logo">
																				{item.logo
																					? <img src={item.logo} alt={item.get_lang ? item.get_lang.name : item.name} />
																					: <span>{item.get_lang ? item.get_lang.name : item.name}</span>
																				}
																			</div>
																			<p className="search-brand-name">{item.get_lang ? item.get_lang.name : item.name}</p>
																		</Link>
																	))
																	: ""}
															</div>
														</div>

														{/* Col 3 — AI metadata (only shown for AI results) */}
														{AI_SEARCH_ENABLED && product.data.ai_powered && (() => {
															const prods = product.data.current_product.data || [];
															const genders = [...new Set(prods.filter(p => p.category?.name).map(p => p.category.name))];
															// Deduplicate accords by name, keep color for tag styling
															const accordMap = new Map();
															prods.forEach(p => (p.notes || []).forEach(n => { if (n.name && !accordMap.has(n.name)) accordMap.set(n.name, n.color || null); }));
															const accords = [...accordMap.entries()].map(([name, color]) => ({ name, color }));
															const topNotes    = [...new Set(prods.flatMap(p => p.scent_notes?.top    || []))];
															const middleNotes = [...new Set(prods.flatMap(p => p.scent_notes?.middle || []))];
															const baseNotes   = [...new Set(prods.flatMap(p => p.scent_notes?.base   || []))];
															return (
																<div className="col-lg-2 col-12 search-col-card search-col-ai-meta">
																	{genders.length > 0 && (
																		<div className="search-meta-row">
																			<p className="title-search">{strings.gender}</p>
																			<div className="search-tag-list">
																				{genders.map((g, i) => (
																					<span key={i} className="search-meta-tag">{g}</span>
																				))}
																			</div>
																		</div>
																	)}
																	{accords.length > 0 && (
																		<div className="search-meta-row">
																			<p className="title-search">{strings.scent_accords}</p>
																			<div className="search-tag-list">
																				{accords.map((a, i) => (
																					<Link
																						key={i}
																						to={'/product?accord=' + encodeURIComponent(a.name)}
																						className="search-meta-tag search-meta-tag--accord"
																						style={a.color ? { background: `linear-gradient(135deg, ${a.color}30 0%, ${a.color}65 100%)` } : undefined}
																						onClick={() => { setSearchText(''); setDropdownOpen(false); setShowSuggestions(false); }}
																					>
																						{a.name}
																					</Link>
																				))}
																			</div>
																		</div>
																	)}
																	{(topNotes.length > 0 || middleNotes.length > 0 || baseNotes.length > 0) && (
																		<div className="search-meta-row">
																			<p className="title-search">{strings.scent_notes}</p>
																			{topNotes.length > 0 && (
																				<div className="search-note-tier">
																					<span className="search-note-tier-label">{strings.top_notes}</span>
																					<div className="search-tag-list">
																						{topNotes.map((n, i) => (
					<Link
						key={i}
						to={'/product?note=' + encodeURIComponent(n)}
						className="search-meta-tag search-meta-tag--note"
						onClick={() => { setSearchText(''); setDropdownOpen(false); setShowSuggestions(false); }}
					>{n}</Link>
				))}
																					</div>
																				</div>
																			)}
																			{middleNotes.length > 0 && (
																				<div className="search-note-tier">
																					<span className="search-note-tier-label">{strings.middle_notes}</span>
																					<div className="search-tag-list">
																						{middleNotes.map((n, i) => (
					<Link
						key={i}
						to={'/product?note=' + encodeURIComponent(n)}
						className="search-meta-tag search-meta-tag--note"
						onClick={() => { setSearchText(''); setDropdownOpen(false); setShowSuggestions(false); }}
					>{n}</Link>
				))}
																					</div>
																				</div>
																			)}
																			{baseNotes.length > 0 && (
																				<div className="search-note-tier">
																					<span className="search-note-tier-label">{strings.base_notes}</span>
																					<div className="search-tag-list">
																						{baseNotes.map((n, i) => (
					<Link
						key={i}
						to={'/product?note=' + encodeURIComponent(n)}
						className="search-meta-tag search-meta-tag--note"
						onClick={() => { setSearchText(''); setDropdownOpen(false); setShowSuggestions(false); }}
					>{n}</Link>
				))}
																					</div>
																				</div>
																			)}
																		</div>
																	)}
																</div>
															);
														})()}
													</div>
												</>
												: ""}
										</div>

									</div>{/* /form-group */}
									<div className="head-right">
										<div className="country-slt desktop_menu">
											<div className="select">
												<select onChange={changeCurrency}>
													{country.data
														? country.data.map(
															(item, index) => (
																<option
																	value={
																		item.currency_difference
																	}
																	selected={
																		currentCurrency.country_code ==
																			item.country_code
																			? true
																			: false
																	}
																>
																	{
																		item.country_code
																	}
																</option>
															)
														)
														: ""}
												</select>
											</div>
										</div>
										<ul className="mobile_fix_menu">
											<li className="desktop_menu_none">
												<Link to="/" className="active">
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="22.911"
														height="21.381"
														viewBox="0 0 22.911 21.381"
													>
														<g
															id="home"
															transform="translate(-0.999 -2.001)"
															fill="none"
														>
															<path
																d="M23.8,13.11a1.692,1.692,0,0,1-1.6,1.109h-.583v8.4a.764.764,0,0,1-.764.764H16.273V18.037a3.818,3.818,0,1,0-7.637,0v5.346H4.054a.764.764,0,0,1-.764-.764v-8.4H2.707a1.709,1.709,0,0,1-1.123-2.994L10.5,2.778a2.84,2.84,0,0,1,3.9,0l8.94,8.466A1.683,1.683,0,0,1,23.8,13.11Z"
																stroke="none"
															/>
															<path
																d="M 20.11856079101562 21.88271903991699 L 20.11856079101562 12.7188196182251 L 22.20199012756348 12.7188196182251 C 22.31827926635742 12.7188196182251 22.37042045593262 12.64493942260742 22.39368057250977 12.5829496383667 C 22.42873001098633 12.48954963684082 22.4025707244873 12.41125965118408 22.3610897064209 12.37509918212891 L 22.31534004211426 12.33352947235107 L 13.37518978118896 3.86760950088501 C 13.12569999694824 3.631359338760376 12.79889011383057 3.501249551773071 12.4549503326416 3.501249551773071 C 12.11081027984619 3.501249551773071 11.78365993499756 3.631489515304565 11.53415966033936 3.867589473724365 L 2.570389986038208 12.35456943511963 C 2.482289791107178 12.43146991729736 2.491580009460449 12.52162933349609 2.514879941940308 12.58371925354004 C 2.548049926757812 12.67209911346436 2.614329814910889 12.7188196182251 2.706569910049438 12.7188196182251 L 4.790770053863525 12.7188196182251 L 4.790770053863525 21.88271903991699 L 7.136369705200195 21.88271903991699 L 7.136369705200195 18.037109375 C 7.136369705200195 15.10458946228027 9.522139549255371 12.7188196182251 12.4546594619751 12.7188196182251 C 15.38718032836914 12.7188196182251 17.77294921875 15.10458946228027 17.77294921875 18.037109375 L 17.77294921875 21.88271903991699 L 20.11856079101562 21.88271903991699 M 20.85490036010742 23.38271903991699 L 16.27294921875 23.38271903991699 L 16.27294921875 18.037109375 C 16.27294921875 15.93170928955078 14.5600700378418 14.2188196182251 12.4546594619751 14.2188196182251 C 10.3492603302002 14.2188196182251 8.636369705200195 15.93170928955078 8.636369705200195 18.037109375 L 8.636369705200195 23.38271903991699 L 4.054419994354248 23.38271903991699 C 3.632889986038208 23.38271903991699 3.290769815444946 23.04059982299805 3.290769815444946 22.61905860900879 L 3.290769815444946 14.2188196182251 L 2.706569910049438 14.2188196182251 C 1.989489912986755 14.2188196182251 1.363289952278137 13.78429985046387 1.110519886016846 13.11075973510742 C 0.857749879360199 12.4372091293335 1.043319940567017 11.69645977020264 1.583989858627319 11.22451972961426 L 10.5027494430542 2.778459548950195 C 11.59784126281738 1.742178678512573 13.31225204467773 1.742180109024048 14.406569480896 2.778459548950195 L 23.34671974182129 11.2443790435791 C 23.86447906494141 11.69569969177246 24.05080986022949 12.43644905090332 23.79804039001465 13.10998916625977 C 23.54526901245117 13.78353977203369 22.91906929016113 14.2188196182251 22.20199012756348 14.2188196182251 L 21.61856079101562 14.2188196182251 L 21.61856079101562 22.61905860900879 C 21.61856079101562 23.04059982299805 21.27643966674805 23.38271903991699 20.85490036010742 23.38271903991699 Z"
																stroke="none"
																fill="#000"
															/>
														</g>
													</svg>
													<span className="desktop_menu_none">
														{strings.home}
													</span>
												</Link>
											</li>

											<li>
												<Link to="/cart" onClick={handleCartIconClick}>
													<span className="mobile_relative">
														<svg
															id="cart"
															xmlns="http://www.w3.org/2000/svg"
															width="21.373"
															height="21.381"
															viewBox="0 0 21.373 21.381"
														>
															<g
																id="Layer_2"
																data-name="Layer 2"
																transform="translate(0 0)"
															>
																<path
																	id="Path_3977"
																	data-name="Path 3977"
																	d="M19.882,25.537H7.547A4.5,4.5,0,0,1,3.99,23.788a4.551,4.551,0,0,1-.81-3.9L5.68,9.628A.823.823,0,0,1,6.5,9H20.277a.823.823,0,0,1,.822.579l3.109,10.055a4.56,4.56,0,0,1-.683,4.06,4.441,4.441,0,0,1-3.643,1.844ZM7.119,10.654,4.742,20.287a2.907,2.907,0,0,0,.517,2.475,2.873,2.873,0,0,0,2.255,1.122H19.849a2.824,2.824,0,0,0,2.294-1.174,2.907,2.907,0,0,0,.436-2.588l-2.895-9.468Z"
																	transform="translate(-3.041 -4.156)"
																/>
																<path
																	id="Path_3978"
																	data-name="Path 3978"
																	d="M18.265,14.3a.807.807,0,0,1-.807-.807V7.036a2.422,2.422,0,1,0-4.844,0v6.458a.807.807,0,0,1-1.615,0V7.036a4.036,4.036,0,0,1,8.073,0v6.458A.807.807,0,0,1,18.265,14.3Z"
																	transform="translate(-4.38 -3)"
																/>
															</g>
														</svg>
														<span className="count_cls">
															{comman.cartCount}
														</span>
													</span>
													<span className="desktop_menu_none">
														{strings.beg}
													</span>
												</Link>
											</li>
											{user && (user.details.temp_user == 0 || user.details.temp_user == 1) ? (
												<li>
													<Link to="/wishlist">
														<span className="mobile_relative">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="24.514"
																height="21.382"
																viewBox="0 0 24.514 21.382"
															>
																<g
																	id="heart"
																	transform="translate(-1.549 -2.998)"
																	fill="none"
																	strokeLinecap="round"
																	strokeLinejoin="round"
																>
																	<path
																		d="M24.173,4.888a6.45,6.45,0,0,0-9.124,0L13.806,6.132,12.562,4.888a6.452,6.452,0,1,0-9.124,9.124l1.243,1.243,9.124,9.124,9.124-9.124,1.243-1.243a6.45,6.45,0,0,0,0-9.124Z"
																		stroke="none"
																	/>
																	<path
																		d="M 19.61067771911621 4.498172760009766 C 18.28799819946289 4.498172760009766 17.04460716247559 5.013372421264648 16.10930633544922 5.949111938476562 L 14.86618709564209 7.192232131958008 C 14.28039836883545 7.778024673461914 13.33065795898438 7.778024673461914 12.7448673248291 7.192232131958008 L 11.50174713134766 5.949111938476562 C 10.56649780273438 5.013862609863281 9.323026657104492 4.498802185058594 8.000377655029297 4.498802185058594 C 6.677738189697266 4.498802185058594 5.434267044067383 5.013862609863281 4.499017715454102 5.949111938476562 C 2.568357467651367 7.879772186279297 2.568367004394531 11.02118301391602 4.499017715454102 12.95184230804443 L 13.80552673339844 22.25834274291992 L 23.1122875213623 12.95158290863037 C 24.04777717590332 12.01653289794922 24.5629768371582 10.77315235137939 24.5629768371582 9.450471878051758 C 24.5629768371582 8.127801895141602 24.04777717590332 6.88441276550293 23.11178779602051 5.948862075805664 C 22.17673683166504 5.013372421264648 20.93334770202637 4.498172760009766 19.61067771911621 4.498172760009766 M 19.61067581176758 2.998174667358398 C 21.26189041137695 2.998174667358398 22.91310119628906 3.628267288208008 24.17269706726074 4.888452529907227 C 26.69306755065918 7.407642364501953 26.69306755065918 11.49331283569336 24.17269706726074 14.01249313354492 L 13.80552768707275 24.37966346740723 L 3.438356399536133 14.01250267028809 C 0.9188270568847656 11.49296283721924 0.9188270568847656 7.407981872558594 3.438356399536133 4.888452529907227 C 5.957901000976562 2.368919372558594 10.04286766052246 2.368923187255859 12.56240749359131 4.888452529907227 L 13.80552768707275 6.131572723388672 L 15.04864692687988 4.888452529907227 C 16.30824661254883 3.628267288208008 17.9594612121582 2.998174667358398 19.61067581176758 2.998174667358398 Z"
																		stroke="none"
																		fill="#000"
																	/>
																</g>
															</svg>
															<span className="count_cls">
																{comman.wishListCount}
															</span>
														</span>
														<span className="desktop_menu_none">

															{strings.wishlist}
														</span>
													</Link>
												</li>
											) : (
												<li>
													<Link to="#" onClick={handleShowSignBox}>
														<svg
															xmlns="http://www.w3.org/2000/svg"
															width="24.514"
															height="21.382"
															viewBox="0 0 24.514 21.382"
														>
															<g
																id="heart"
																transform="translate(-1.549 -2.998)"
																fill="none"
																strokeLinecap="round"
																strokeLinejoin="round"
															>
																<path
																	d="M24.173,4.888a6.45,6.45,0,0,0-9.124,0L13.806,6.132,12.562,4.888a6.452,6.452,0,1,0-9.124,9.124l1.243,1.243,9.124,9.124,9.124-9.124,1.243-1.243a6.45,6.45,0,0,0,0-9.124Z"
																	stroke="none"
																/>
																<path
																	d="M 19.61067771911621 4.498172760009766 C 18.28799819946289 4.498172760009766 17.04460716247559 5.013372421264648 16.10930633544922 5.949111938476562 L 14.86618709564209 7.192232131958008 C 14.28039836883545 7.778024673461914 13.33065795898438 7.778024673461914 12.7448673248291 7.192232131958008 L 11.50174713134766 5.949111938476562 C 10.56649780273438 5.013862609863281 9.323026657104492 4.498802185058594 8.000377655029297 4.498802185058594 C 6.677738189697266 4.498802185058594 5.434267044067383 5.013862609863281 4.499017715454102 5.949111938476562 C 2.568357467651367 7.879772186279297 2.568367004394531 11.02118301391602 4.499017715454102 12.95184230804443 L 13.80552673339844 22.25834274291992 L 23.1122875213623 12.95158290863037 C 24.04777717590332 12.01653289794922 24.5629768371582 10.77315235137939 24.5629768371582 9.450471878051758 C 24.5629768371582 8.127801895141602 24.04777717590332 6.88441276550293 23.11178779602051 5.948862075805664 C 22.17673683166504 5.013372421264648 20.93334770202637 4.498172760009766 19.61067771911621 4.498172760009766 M 19.61067581176758 2.998174667358398 C 21.26189041137695 2.998174667358398 22.91310119628906 3.628267288208008 24.17269706726074 4.888452529907227 C 26.69306755065918 7.407642364501953 26.69306755065918 11.49331283569336 24.17269706726074 14.01249313354492 L 13.80552768707275 24.37966346740723 L 3.438356399536133 14.01250267028809 C 0.9188270568847656 11.49296283721924 0.9188270568847656 7.407981872558594 3.438356399536133 4.888452529907227 C 5.957901000976562 2.368919372558594 10.04286766052246 2.368923187255859 12.56240749359131 4.888452529907227 L 13.80552768707275 6.131572723388672 L 15.04864692687988 4.888452529907227 C 16.30824661254883 3.628267288208008 17.9594612121582 2.998174667358398 19.61067581176758 2.998174667358398 Z"
																	stroke="none"
																	fill="#000"
																/>
															</g>
														</svg>
														<span className="count_cls">
															{0}
														</span>
														<span className="desktop_menu_none">

															{strings.wishlist}
														</span>
													</Link>
												</li>
											)}
											{user && user.details.temp_user == 0 ? (
												<li>
													<Dropdown className="login_after">
														<Dropdown.Toggle
															variant="outline"
															id="dropdown-basic"
														>
															<svg
																id="login"
																xmlns="http://www.w3.org/2000/svg"
																width="21.415"
																height="21.381"
																viewBox="0 0 21.415 21.381"
															>
																<g
																	id="user"
																	transform="translate(0 0)"
																>
																	<g
																		id="Ellipse_519"
																		data-name="Ellipse 519"
																		transform="translate(5.362)"
																		fill="none"
																		stroke="#000"
																		strokeWidth="1.5"
																	>
																		<ellipse
																			cx="5.345"
																			cy="6.414"
																			rx="5.345"
																			ry="6.414"
																			stroke="none"
																		/>
																		<ellipse
																			cx="5.345"
																			cy="6.414"
																			rx="4.595"
																			ry="5.664"
																			fill="none"
																		/>
																	</g>
																	<g
																		id="Path_15427"
																		data-name="Path 15427"
																		transform="translate(-1.984 -1.119)"
																		fill="none"
																	>
																		<path
																			d="M23.169,19.4a9.743,9.743,0,0,0-5.132-4.49,2.394,2.394,0,0,0-1.924.107,6.563,6.563,0,0,1-6.842,0,2.406,2.406,0,0,0-1.924,0,9.743,9.743,0,0,0-5.132,4.49A2.11,2.11,0,0,0,4.246,22.5H21.138A2.165,2.165,0,0,0,23.169,19.4Z"
																			stroke="none"
																		/>
																		<path
																			d="M 21.13755035400391 21.00003051757812 C 21.4713306427002 21.00003051757812 21.70491027832031 20.81451225280762 21.81222152709961 20.64089202880859 C 21.92385101318359 20.46027183532715 21.92873001098633 20.27371215820312 21.82715034484863 20.0705509185791 C 21.02771949768066 18.4716968536377 19.50029754638672 17.14137077331543 17.52240180969238 16.31984901428223 C 17.39455795288086 16.28152084350586 17.25908279418945 16.26061058044434 17.1365909576416 16.26061058044434 C 16.98755073547363 16.26061058044434 16.90419006347656 16.29105186462402 16.88463020324707 16.30278205871582 C 15.54751110076904 17.10504150390625 14.21522045135498 17.47870063781738 12.69185066223145 17.47870063781738 C 11.21662425994873 17.47870063781738 9.920726776123047 17.12835884094238 8.625997543334961 16.37765502929688 C 8.49944019317627 16.33687400817871 8.366772651672363 16.31412124633789 8.250990867614746 16.31412124633789 C 8.1845703125 16.31412124633789 8.090110778808594 16.32176208496094 8.017291069030762 16.3581714630127 L 7.966740608215332 16.38345146179199 L 7.914420604705811 16.40485191345215 C 5.910770893096924 17.22453117370605 4.363110542297363 18.5643310546875 3.556550741195679 20.17745208740234 L 3.53562068939209 20.21778106689453 C 3.503470659255981 20.27749061584473 3.428170680999756 20.41732215881348 3.55418062210083 20.62828063964844 C 3.656610727310181 20.79977226257324 3.899300575256348 21.00003051757812 4.246150493621826 21.00003051757812 L 21.13755035400391 21.00003051757812 M 21.13755035400391 22.50003051757812 L 4.246150493621826 22.50003051757812 C 2.642540693283081 22.50003051757812 1.4665607213974 20.89643096923828 2.214910745620728 19.50663185119629 C 3.177080631256104 17.58230209350586 4.994510650634766 15.9787015914917 7.346470832824707 15.01653099060059 C 7.987920761108398 14.69581413269043 8.736269950866699 14.80272197723389 9.270811080932617 15.01654148101807 C 10.33988094329834 15.65798091888428 11.40896034240723 15.9787015914917 12.69185066223145 15.9787015914917 C 13.97474098205566 15.9787015914917 15.04381084442139 15.65798091888428 16.11289024353027 15.01654148101807 C 16.64743041992188 14.69580936431885 17.39577865600586 14.69581127166748 18.0372314453125 14.90963172912598 C 20.38919067382812 15.87179183959961 22.20662117004395 17.47540092468262 23.16879081726074 19.39973068237305 C 23.91714096069336 20.89643096923828 22.74116134643555 22.50003051757812 21.13755035400391 22.50003051757812 Z"
																			stroke="none"
																			fill="#000"
																		/>
																	</g>
																</g>
															</svg>
															<span className="desktop_menu_none" onClick={(e) => addClass(e, "filter")}>
																{
																	strings.account
																}
															</span>
															<span className="desktop-menu">
																{user.details
																	.name
																	? user
																		.details
																		.name
																	: user
																		.details
																		.mobile}
															</span>
														</Dropdown.Toggle>

														<Dropdown.Menu className="dropdown-menu">
															<button onClick={removeClass} type="button" className="btn_cross d-md-none"><img src={Imgcross} alt="Close" /></button>
															<li>
																<Link
																	className="dropdown-item"
																	to="/profile"
																	onClick={removeClass}
																>
																	<span>
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="21"
																			height="21"
																			viewBox="0 0 21 21"
																		>
																			<g
																				id="_1814089_account_user_person_profile_avatar_icon"
																				data-name="1814089_account_user_person_profile_avatar_icon"
																				transform="translate(-8.1 -8.1)"
																			>
																				<g
																					id="Icon-User"
																					transform="translate(8.1 8.1)"
																				>
																					<path
																						id="Fill-57"
																						d="M-259.4-248.9a10.5,10.5,0,0,1-10.5-10.5,10.5,10.5,0,0,1,10.5-10.5,10.5,10.5,0,0,1,10.5,10.5,10.5,10.5,0,0,1-10.5,10.5Zm0-19.858a9.394,9.394,0,0,0-9.358,9.358,9.394,9.394,0,0,0,9.358,9.358,9.394,9.394,0,0,0,9.358-9.358,9.394,9.394,0,0,0-9.358-9.358Z"
																						transform="translate(269.9 269.9)"
																					/>
																					<path
																						id="Fill-58"
																						d="M-261.346-248.66l-1.054-.483c.308-.747,1.274-1.142,2.372-1.626,1.054-.483,2.372-1.054,2.372-1.757v-.967a2.961,2.961,0,0,1-1.1-2.021,2.373,2.373,0,0,1-.791-1.582,1.965,1.965,0,0,1,.308-1.01,13.675,13.675,0,0,1-.264-2.2c0-2.416,1.669-4,4.305-4a3.069,3.069,0,0,1,2.153.747,3.179,3.179,0,0,1,2.153,3.251,8.17,8.17,0,0,1-.308,2.328,1.731,1.731,0,0,1,.264.879,1.881,1.881,0,0,1-.791,1.626,2.986,2.986,0,0,1-1.01,1.977v.967c0,.615,1.1,1.01,2.109,1.406,1.186.439,2.416.879,2.812,1.889l-1.1.4c-.176-.527-1.23-.879-2.109-1.23-1.362-.483-2.9-1.054-2.9-2.46v-1.582l.264-.176a1.824,1.824,0,0,0,.791-1.538v-.4l.351-.132a.845.845,0,0,0,.4-.747.664.664,0,0,0-.176-.4l-.22-.264.088-.308a8.3,8.3,0,0,0,.308-2.285c0-1.1-.615-2.109-1.274-2.109h-.351l-.176-.308a1.746,1.746,0,0,0-1.362-.439c-1.977,0-3.163,1.054-3.163,2.856a13.089,13.089,0,0,0,.308,2.2l.088.308-.22.22a.838.838,0,0,0-.176.439c0,.308.4.7.571.879l.22.176v.308a1.9,1.9,0,0,0,.835,1.494l.264.176v1.582c0,1.45-1.626,2.2-3.075,2.812a6.793,6.793,0,0,0-1.713,1.1"
																						transform="translate(265.695 266.76)"
																					/>
																				</g>
																			</g>
																		</svg>
																	</span>
																	{
																		strings.myaccount
																	}
																</Link>
															</li>
															<li>
																{<Link
																	className="dropdown-item"
																	to="/wallet"
																	onClick={removeClass}
																>
																	<span>
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="20.993"
																			height="21"
																			viewBox="0 0 20.993 21"
																		>
																			<g
																				id="_4781810_coin_currency_dollar_finance_money_icon"
																				data-name="4781810_coin_currency_dollar_finance_money_icon"
																				transform="translate(-3 -2.991)"
																			>
																				<g
																					id="Layer_2"
																					data-name="Layer 2"
																					transform="translate(3 2.991)"
																				>
																					<path
																						id="Path_15669"
																						data-name="Path 15669"
																						d="M19.956,25.148H7.037A4.037,4.037,0,0,1,3,21.111V9.807A.807.807,0,0,1,3.807,9H19.956a4.037,4.037,0,0,1,4.037,4.037v8.074A4.037,4.037,0,0,1,19.956,25.148ZM4.615,10.615v10.5a2.422,2.422,0,0,0,2.422,2.422H19.956a2.422,2.422,0,0,0,2.422-2.422V13.037a2.422,2.422,0,0,0-2.422-2.422Z"
																						transform="translate(-3 -4.148)"
																					/>
																					<path
																						id="Path_15670"
																						data-name="Path 15670"
																						d="M21.571,9.458a.807.807,0,0,1-.807-.807V6.43a1.881,1.881,0,0,0-.63-1.51,1.566,1.566,0,0,0-1.348-.258L5.245,7.738a.807.807,0,0,0-.63.807A.807.807,0,0,1,3,8.545,2.422,2.422,0,0,1,4.881,6.163L18.43,3.087a3.149,3.149,0,0,1,2.713.573A3.5,3.5,0,0,1,22.378,6.43V8.65A.807.807,0,0,1,21.571,9.458Z"
																						transform="translate(-3 -2.991)"
																					/>
																					<path
																						id="Path_15671"
																						data-name="Path 15671"
																						d="M25.882,21.459H20.23a3.23,3.23,0,1,1,0-6.459h5.652a.807.807,0,0,1,.807.807v4.845A.807.807,0,0,1,25.882,21.459ZM20.23,16.615a1.615,1.615,0,1,0,0,3.23h4.845v-3.23Z"
																						transform="translate(-5.696 -5.304)"
																					/>
																				</g>
																			</g>
																		</svg>
																	</span>

																	{
																		strings.myWallet
																	}
																</Link>}
															</li>
															<li>
																<Link
																	onClick={removeClass}
																	className="dropdown-item"
																	to="/order"
																>
																	<span>
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="21"
																			height="21"
																			viewBox="0 0 21 21"
																		>
																			<g
																				id="Group_5049"
																				data-name="Group 5049"
																				transform="translate(-174.635 -4216)"
																			>
																				<g
																					id="Ellipse_516"
																					data-name="Ellipse 516"
																					transform="translate(174.635 4216)"
																					fill="none"
																					stroke="#000"
																					strokeWidth="1"
																				>
																					<circle
																						cx="10.5"
																						cy="10.5"
																						r="10.5"
																						stroke="none"
																					/>
																					<circle
																						cx="10.5"
																						cy="10.5"
																						r="10"
																						fill="none"
																					/>
																				</g>
																				<path
																					id="_8665903_table_list_icon"
																					data-name="8665903_table_list_icon"
																					d="M9.984,32H1.426A1.426,1.426,0,0,0,0,33.426v7.132a1.426,1.426,0,0,0,1.426,1.426H9.984a1.426,1.426,0,0,0,1.426-1.426V33.426A1.427,1.427,0,0,0,9.984,32ZM1.426,33.426H2.853v1.426H1.426Zm0,2.853H2.853v1.426H1.426Zm0,4.279V39.132H2.853v1.426Zm8.558,0H4.279V39.132H9.984Zm0-2.853H4.279V36.279H9.984Zm0-2.853H4.279V33.426H9.984Z"
																					transform="translate(179.404 4189.404)"
																				/>
																			</g>
																		</svg>
																	</span>

																	{
																		strings.myOrder
																	}
																</Link>
															</li>
															<li>
																<Link
																	onClick={removeClass}
																	className="dropdown-item"
																	to="/wishlist"
																>
																	<span>
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="21"
																			height="18.317"
																			viewBox="0 0 21 18.317"
																		>
																			<g
																				id="_8666647_heart_icon"
																				data-name="8666647_heart_icon"
																				transform="translate(-1.549 -2.998)"
																				fill="none"
																				strokeLinecap="round"
																				strokeLinejoin="round"
																			>
																				<path
																					d="M20.93,4.618a5.526,5.526,0,0,0-7.816,0L12.049,5.682,10.984,4.618a5.527,5.527,0,0,0-7.816,7.816L4.232,13.5l7.816,7.816L19.865,13.5l1.065-1.065a5.526,5.526,0,0,0,0-7.816Z"
																					stroke="none"
																				/>
																				<path
																					d="M 17.02173614501953 3.998170852661133 C 15.81249523162842 3.998170852661133 14.67574596405029 4.469181060791016 13.820725440979 5.324602127075195 L 12.7557954788208 6.389541625976562 C 12.36527442932129 6.780073165893555 11.73210430145264 6.780069351196289 11.34158515930176 6.389551162719727 L 10.27663516998291 5.324621200561523 C 9.421615600585938 4.46959114074707 8.284805297851562 3.998710632324219 7.075626373291016 3.998710632324219 C 5.866445541381836 3.998710632324219 4.729635238647461 4.46959114074707 3.874614715576172 5.324621200561523 C 2.109575271606445 7.08966064453125 2.109575271606445 9.961601257324219 3.874605178833008 11.72664165496826 L 12.04868602752686 19.90071105957031 L 20.22292518615723 11.72648143768311 C 21.07818603515625 10.87162113189697 21.54919624328613 9.734871864318848 21.54919624328613 8.525631904602051 C 21.54919624328613 7.316390991210938 21.07818603515625 6.179641723632812 20.22259521484375 5.324451446533203 C 19.36773490905762 4.46919059753418 18.23097610473633 3.998170852661133 17.02173614501953 3.998170852661133 M 17.0217399597168 2.998170852661133 C 18.43627548217773 2.998170852661133 19.85081481933594 3.537952423095703 20.92986488342285 4.617511749267578 C 23.08897590637207 6.775602340698242 23.08897590637207 10.2756519317627 20.92986488342285 12.43375110626221 L 12.04868602752686 21.31493186950684 L 3.167505264282227 12.43375110626221 C 1.009115219116211 10.27535152435303 1.009115219116211 6.775901794433594 3.167505264282227 4.617511749267578 C 5.325904846191406 2.459110260009766 8.825343132019043 2.459108352661133 10.98374557495117 4.617511749267578 L 12.04868602752686 5.682441711425781 L 13.11361598968506 4.617502212524414 C 14.19267082214355 3.537946701049805 15.60720348358154 2.9981689453125 17.0217399597168 2.998170852661133 Z"
																					stroke="none"
																					fill="#000"
																				/>
																			</g>
																		</svg>
																	</span>
																	{
																		strings.myWishlist
																	}
																</Link>
															</li>
															{/*<li>
																<Link
																	className="dropdown-item"
																	to="/my-card"
																	onClick={removeClass}
																>
																	<span>
																		<svg
																			id="Camada_2"
																			data-name="Camada 2"
																			xmlns="http://www.w3.org/2000/svg"
																			width="21"
																			height="14.878"
																			viewBox="0 0 21 14.878"
																		>
																			<g
																				id="Camada_1"
																				data-name="Camada 1"
																				transform="translate(0 0)"
																			>
																				<path
																					id="Path_15672"
																					data-name="Path 15672"
																					d="M19.238,1.841h-.079V1.709A1.709,1.709,0,0,0,17.459,0H1.709A1.709,1.709,0,0,0,0,1.709v9.619a1.709,1.709,0,0,0,1.709,1.709h.132v.079A1.762,1.762,0,0,0,3.6,14.878H19.238A1.762,1.762,0,0,0,21,13.116V3.6a1.762,1.762,0,0,0-1.762-1.762ZM.881,3.065H18.287V4.88H.881ZM1.709.881h15.75a.828.828,0,0,1,.828.828v.476H.881V1.709A.828.828,0,0,1,1.709.881ZM.881,11.328V5.761H18.287v5.567a.828.828,0,0,1-.828.828H1.709A.828.828,0,0,1,.881,11.328ZM20.119,13.09a.881.881,0,0,1-.881.881H3.6a.881.881,0,0,1-.881-.881v-.053H17.459a1.709,1.709,0,0,0,1.709-1.709V2.722h.079a.881.881,0,0,1,.881.881Z"
																					transform="translate(0 0)"
																				/>
																				<path
																					id="Path_15673"
																					data-name="Path 15673"
																					d="M14.879,12.066a1.573,1.573,0,0,0,1.145-.454,1.582,1.582,0,1,0,0-2.167,1.573,1.573,0,1,0-1.145,2.622ZM17.16,9.785a.708.708,0,1,1-.708.708.708.708,0,0,1,.708-.708Zm-2.281,0a.708.708,0,1,1-.708.708.708.708,0,0,1,.708-.708Z"
																					transform="translate(-1.549 -1.045)"
																				/>
																			</g>
																		</svg>
																	</span>
																	{
																		strings.myCards
																	}
																</Link>
																</li>*/}
															<li>
																<Link
																	className="dropdown-item"
																	to="/notification"
																	onClick={removeClass}
																>
																	<span>
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="19.095"
																			height="21"
																			viewBox="0 0 19.095 21"
																		>
																			<path
																				id="_290107_alarm_alert_bell_christmas_notification_icon"
																				data-name="290107_alarm_alert_bell_christmas_notification_icon"
																				d="M15.448,21.075c0,.009,0,.017,0,.027a1.9,1.9,0,1,1-3.807,0c0-.009,0-.017,0-.027C5.56,20.908,4,19.916,4,18.715a1.3,1.3,0,0,1,.564-1.047C7.441,14.462,8.3,15.349,8.3,10.6c0-3.166.129-6.068,3.942-6.591a1.427,1.427,0,1,1,2.618,0C18.669,4.532,18.8,7.435,18.8,10.6c0,4.763.859,3.854,3.758,7.094a1.289,1.289,0,0,1,.538,1.02C23.1,19.915,21.494,20.907,15.448,21.075Zm-1.9.981A.953.953,0,0,0,14.5,21.1s0-.006,0-.009c-.311,0-.619.009-.951.009s-.64,0-.951-.009c0,0,0,.006,0,.009A.953.953,0,0,0,13.548,22.056Zm0-19.093a.477.477,0,1,0,.476.477A.476.476,0,0,0,13.548,2.963Zm8.4,15.47s-.727-.818-1.918-1.9c-1.627-1.482-2.19-2.185-2.19-5.931,0-3.659-.2-5.729-4.3-5.729s-4.3,2.07-4.3,5.729c0,3.746-.563,4.45-2.191,5.932-1.168,1.064-1.9,1.882-1.9,1.882-.2.161-.2.254-.2.3s.1,1.434,8.593,1.434,8.593-1.375,8.593-1.434C22.14,18.677,22.14,18.587,21.952,18.434Z"
																				transform="translate(-4 -2.01)"
																				fillRule="evenodd"
																			/>
																		</svg>
																	</span>
																	{
																		strings.notifications
																	}
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item"
																	to="#"
																	onClick={
																		handleLogout
																	}
																>
																	<span>
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="21"
																			height="16"
																			viewBox="0 0 21 16"
																		>
																			<g
																				id="_8656276_logout_application_system_website_social_media_icon"
																				data-name="8656276_logout_application_system_website_social media_icon"
																				transform="translate(-1.5 -4)"
																			>
																				<path
																					id="Path_15674"
																					data-name="Path 15674"
																					d="M2,12.5H14v-1H2Z"
																					fillRule="evenodd"
																				/>
																				<path
																					id="Path_15675"
																					data-name="Path 15675"
																					d="M5.146,8.146l-3.5,3.5a.5.5,0,0,0,0,.707l3.5,3.5.707-.707L2.707,12,5.854,8.854Z"
																					fillRule="evenodd"
																				/>
																				<path
																					id="Path_15676"
																					data-name="Path 15676"
																					d="M14.6,5A6.894,6.894,0,0,0,8.446,8.813l-.893-.451A7.89,7.89,0,0,1,22.5,12,7.89,7.89,0,0,1,7.554,15.638l.893-.451A6.89,6.89,0,0,0,21.5,12,6.953,6.953,0,0,0,14.6,5Z"
																					fillRule="evenodd"
																				/>
																			</g>
																		</svg>
																	</span>

																	{strings.logout}
																</Link>
															</li>
														</Dropdown.Menu>
													</Dropdown>
												</li>
											) : (
												<li>
													<Link to="#" onClick={handleShowSignBox} >
														<svg
															id="login"
															xmlns="http://www.w3.org/2000/svg"
															width="21.415"
															height="21.381"
															viewBox="0 0 21.415 21.381"
														>
															<g
																id="user"
																transform="translate(0 0)"
															>
																<g
																	id="Ellipse_519"
																	data-name="Ellipse 519"
																	transform="translate(5.362)"
																	fill="none"
																	stroke="#000"
																	strokeWidth="1.5"
																>
																	<ellipse
																		cx="5.345"
																		cy="6.414"
																		rx="5.345"
																		ry="6.414"
																		stroke="none"
																	/>
																	<ellipse
																		cx="5.345"
																		cy="6.414"
																		rx="4.595"
																		ry="5.664"
																		fill="none"
																	/>
																</g>
																<g
																	id="Path_15427"
																	data-name="Path 15427"
																	transform="translate(-1.984 -1.119)"
																	fill="none"
																>
																	<path
																		d="M23.169,19.4a9.743,9.743,0,0,0-5.132-4.49,2.394,2.394,0,0,0-1.924.107,6.563,6.563,0,0,1-6.842,0,2.406,2.406,0,0,0-1.924,0,9.743,9.743,0,0,0-5.132,4.49A2.11,2.11,0,0,0,4.246,22.5H21.138A2.165,2.165,0,0,0,23.169,19.4Z"
																		stroke="none"
																	/>
																	<path
																		d="M 21.13755035400391 21.00003051757812 C 21.4713306427002 21.00003051757812 21.70491027832031 20.81451225280762 21.81222152709961 20.64089202880859 C 21.92385101318359 20.46027183532715 21.92873001098633 20.27371215820312 21.82715034484863 20.0705509185791 C 21.02771949768066 18.4716968536377 19.50029754638672 17.14137077331543 17.52240180969238 16.31984901428223 C 17.39455795288086 16.28152084350586 17.25908279418945 16.26061058044434 17.1365909576416 16.26061058044434 C 16.98755073547363 16.26061058044434 16.90419006347656 16.29105186462402 16.88463020324707 16.30278205871582 C 15.54751110076904 17.10504150390625 14.21522045135498 17.47870063781738 12.69185066223145 17.47870063781738 C 11.21662425994873 17.47870063781738 9.920726776123047 17.12835884094238 8.625997543334961 16.37765502929688 C 8.49944019317627 16.33687400817871 8.366772651672363 16.31412124633789 8.250990867614746 16.31412124633789 C 8.1845703125 16.31412124633789 8.090110778808594 16.32176208496094 8.017291069030762 16.3581714630127 L 7.966740608215332 16.38345146179199 L 7.914420604705811 16.40485191345215 C 5.910770893096924 17.22453117370605 4.363110542297363 18.5643310546875 3.556550741195679 20.17745208740234 L 3.53562068939209 20.21778106689453 C 3.503470659255981 20.27749061584473 3.428170680999756 20.41732215881348 3.55418062210083 20.62828063964844 C 3.656610727310181 20.79977226257324 3.899300575256348 21.00003051757812 4.246150493621826 21.00003051757812 L 21.13755035400391 21.00003051757812 M 21.13755035400391 22.50003051757812 L 4.246150493621826 22.50003051757812 C 2.642540693283081 22.50003051757812 1.4665607213974 20.89643096923828 2.214910745620728 19.50663185119629 C 3.177080631256104 17.58230209350586 4.994510650634766 15.9787015914917 7.346470832824707 15.01653099060059 C 7.987920761108398 14.69581413269043 8.736269950866699 14.80272197723389 9.270811080932617 15.01654148101807 C 10.33988094329834 15.65798091888428 11.40896034240723 15.9787015914917 12.69185066223145 15.9787015914917 C 13.97474098205566 15.9787015914917 15.04381084442139 15.65798091888428 16.11289024353027 15.01654148101807 C 16.64743041992188 14.69580936431885 17.39577865600586 14.69581127166748 18.0372314453125 14.90963172912598 C 20.38919067382812 15.87179183959961 22.20662117004395 17.47540092468262 23.16879081726074 19.39973068237305 C 23.91714096069336 20.89643096923828 22.74116134643555 22.50003051757812 21.13755035400391 22.50003051757812 Z"
																		stroke="none"
																		fill="#000"
																	/>
																</g>
															</g>
														</svg>
														<span className="desktop_menu_none">
															{strings.account}
														</span>
													</Link>
												</li>
											)}
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className='bottom_header'>
						<Navbar
							key="md"
							expand="md"
							className="navbar navbar-expand-lg navbar-light"
						>
							<Container>
								<Navbar.Toggle
									aria-controls={`offcanvasNavbar-expand-md`}
								/>
								<Navbar.Offcanvas
									id={`offcanvasNavbar-expand-md`}
									aria-labelledby={`offcanvasNavbarLabel-expand-md`}
									placement="start"
								>
									<Offcanvas.Header closeButton>
									</Offcanvas.Header>
									<Offcanvas.Body className="align-items-center">
										<Nav className="flex-grow-1 pe-3">
											<ul className="navbar-nav">
												{setting.data &&
													setting.data.menus.length > 0
													? setting.data.menus.map((item, index) => (
														<li className={Props.new === item.route ? "nav-item inner_dropdown nav-item-color" : "nav-item inner_dropdown"}>
															<a href={item.route} className="nav-link">
																<span className="mobile_menu_ic">
																	<img src={item.icon ?? 'path_to_default_icon'} alt={item.name} />
																</span>
																{item.name}
															</a>
															{item.children && item.children.length > 0 && (
																<div className="subMenu">
																	<ul>
																		{item.children.map((child) => (
																			<li key={child.id}>
																				<a href={child.route}>{child.name}</a>
																			</li>
																		))}
																	</ul>
																</div>
															)}
														</li>
													))
													: ""}

												<li className="nav-item inner_dropdown mega_menu_dropdown">
													<Link
														to="/brand"
														className="nav-link"
													>
														<span className="mobile_menu_ic">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="24"
																height="24"
																viewBox="0 0 24 24"
															>
																<g
																	id="brands"
																	transform="translate(-72.8 -10)"
																>
																	<path
																		id="Path_15498"
																		data-name="Path 15498"
																		d="M96.8,25.075v-7.5A3.182,3.182,0,0,0,95,14.8l-8.294-4.34a4.16,4.16,0,0,0-3.814,0L74.6,14.8a3.185,3.185,0,0,0-1.8,2.77v8.859a3.185,3.185,0,0,0,1.8,2.77l8.294,4.34a4.174,4.174,0,0,0,3.811,0l8.384-4.35-.006-.01a.584.584,0,0,0,.343-.507.648.648,0,0,0-.688-.6.73.73,0,0,0-.345.093l-.006-.007L86,32.511a2.617,2.617,0,0,1-2.4,0l-8.294-4.34a2.008,2.008,0,0,1-1.132-1.741V17.573a2,2,0,0,1,1.132-1.741l8.294-4.34a2.617,2.617,0,0,1,2.4,0l8.3,4.34a2,2,0,0,1,1.129,1.741v7.5h0a.7.7,0,0,0,1.379,0Z"
																	/>
																	<path
																		id="Path_15499"
																		data-name="Path 15499"
																		d="M237.858,202.326l-.384-1.108a.753.753,0,0,0-.823-.427l-1.477.187c-.625.08-1.072-.47-.739-.9l2.321-2.992a4.737,4.737,0,0,1-.847-5.569,6.945,6.945,0,0,1,5.541-3.363c4.207-.4,7.79,2.247,7.79,5.564a4.931,4.931,0,0,1-1.4,3.368l2.321,2.992c.336.432-.114.982-.739.9l-1.478-.187a.755.755,0,0,0-.823.427l-.384,1.108a.812.812,0,0,1-1.333.155l-2.469-3.183a7.518,7.518,0,0,1-1.279,0l-2.471,3.183A.807.807,0,0,1,237.858,202.326Zm5.817-4.318,2.1,2.706.288-.834a.758.758,0,0,1,.823-.427l1.174.148-2.036-2.623.366-.332a3.77,3.77,0,0,0,.892-4.759,5.381,5.381,0,0,0-3.922-2.5c-3.48-.531-6.532,1.622-6.532,4.337a3.961,3.961,0,0,0,1.381,2.926l.366.332L236.54,199.6l1.174-.148a.755.755,0,0,1,.823.427l.288.832,2.1-2.7.483.065a6.865,6.865,0,0,0,1.784,0Z"
																		transform="translate(-157.501 -173.678)"
																	/>
																	<path
																		id="Path_15500"
																		data-name="Path 15500"
																		d="M368.633,284.567l.209-1.217a.611.611,0,0,0-.174-.54l-.886-.861a.61.61,0,0,1,.339-1.04l1.222-.177a.608.608,0,0,0,.458-.334l.548-1.108a.609.609,0,0,1,1.093,0l.545,1.108a.617.617,0,0,0,.458.334l1.222.177a.61.61,0,0,1,.339,1.04l-.884.861a.612.612,0,0,0-.177.54l.209,1.217a.609.609,0,0,1-.884.642l-1.093-.575a.6.6,0,0,0-.568,0l-1.093.575A.608.608,0,0,1,368.633,284.567Zm1.976-1.309a.617.617,0,0,1,.568,0l.568.3-.107-.632a.615.615,0,0,1,.174-.54l.458-.448-.632-.092a.617.617,0,0,1-.461-.334l-.284-.573-.284.575a.617.617,0,0,1-.461.334l-.635.092.458.448a.612.612,0,0,1,.177.54l-.107.632Z"
																		transform="translate(-286.095 -262.4)"
																	/>
																</g>
															</svg>
														</span>
														{strings.brands}
													</Link>
													{setting.data &&
														setting.data.brand.length > 0
														?
														<div className="subMenu megaMenu">

															<ul>
																{setting.data.brand.map(
																	(item, index) => (
																		<li>
																			<Link to={"/brand/" + item.slug}>{item.name}</Link>
																		</li>
																	))}

															</ul>
															<div className="view_all d-flex justify-content-end" id="brandMenu">
																<Link to="/brand/" className="btn btn_primary">{strings.view_all}</Link>
															</div>
														</div> : null}
												</li>

												<li className="nav-item">
													<Link
														to="/sale"
														className="nav-link"
													>
														<span className="mobile_menu_ic">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="24"
																height="24"
																viewBox="0 0 24 24"
															>
																<g
																	id="sale"
																	transform="translate(-72.8 -10)"
																>
																	<path
																		id="Path_15498"
																		data-name="Path 15498"
																		d="M96.8,25.075v-7.5A3.182,3.182,0,0,0,95,14.8l-8.294-4.34a4.16,4.16,0,0,0-3.814,0L74.6,14.8a3.185,3.185,0,0,0-1.8,2.77v8.859a3.185,3.185,0,0,0,1.8,2.77l8.294,4.34a4.174,4.174,0,0,0,3.811,0l8.384-4.35-.006-.01a.584.584,0,0,0,.343-.507.648.648,0,0,0-.688-.6.73.73,0,0,0-.345.093l-.006-.007L86,32.511a2.617,2.617,0,0,1-2.4,0l-8.294-4.34a2.008,2.008,0,0,1-1.132-1.741V17.573a2,2,0,0,1,1.132-1.741l8.294-4.34a2.617,2.617,0,0,1,2.4,0l8.3,4.34a2,2,0,0,1,1.129,1.741v7.5h0a.7.7,0,0,0,1.379,0Z"
																	/>
																	<path
																		id="Path_15499"
																		data-name="Path 15499"
																		d="M237.858,202.326l-.384-1.108a.753.753,0,0,0-.823-.427l-1.477.187c-.625.08-1.072-.47-.739-.9l2.321-2.992a4.737,4.737,0,0,1-.847-5.569,6.945,6.945,0,0,1,5.541-3.363c4.207-.4,7.79,2.247,7.79,5.564a4.931,4.931,0,0,1-1.4,3.368l2.321,2.992c.336.432-.114.982-.739.9l-1.478-.187a.755.755,0,0,0-.823.427l-.384,1.108a.812.812,0,0,1-1.333.155l-2.469-3.183a7.518,7.518,0,0,1-1.279,0l-2.471,3.183A.807.807,0,0,1,237.858,202.326Zm5.817-4.318,2.1,2.706.288-.834a.758.758,0,0,1,.823-.427l1.174.148-2.036-2.623.366-.332a3.77,3.77,0,0,0,.892-4.759,5.381,5.381,0,0,0-3.922-2.5c-3.48-.531-6.532,1.622-6.532,4.337a3.961,3.961,0,0,0,1.381,2.926l.366.332L236.54,199.6l1.174-.148a.755.755,0,0,1,.823.427l.288.832,2.1-2.7.483.065a6.865,6.865,0,0,0,1.784,0Z"
																		transform="translate(-157.501 -173.678)"
																	/>
																	<path
																		id="Path_15500"
																		data-name="Path 15500"
																		d="M368.633,284.567l.209-1.217a.611.611,0,0,0-.174-.54l-.886-.861a.61.61,0,0,1,.339-1.04l1.222-.177a.608.608,0,0,0,.458-.334l.548-1.108a.609.609,0,0,1,1.093,0l.545,1.108a.617.617,0,0,0,.458.334l1.222.177a.61.61,0,0,1,.339,1.04l-.884.861a.612.612,0,0,0-.177.54l.209,1.217a.609.609,0,0,1-.884.642l-1.093-.575a.6.6,0,0,0-.568,0l-1.093.575A.608.608,0,0,1,368.633,284.567Zm1.976-1.309a.617.617,0,0,1,.568,0l.568.3-.107-.632a.615.615,0,0,1,.174-.54l.458-.448-.632-.092a.617.617,0,0,1-.461-.334l-.284-.573-.284.575a.617.617,0,0,1-.461.334l-.635.092.458.448a.612.612,0,0,1,.177.54l-.107.632Z"
																		transform="translate(-286.095 -262.4)"
																	/>
																</g>
															</svg>
														</span>
														{strings.sale}
													</Link>
												</li>

												<li className="nav-item">
													<Link to="/blogs" className="nav-link">
														<span className="mobile_menu_ic" aria-hidden="true">
															<i className="far fa-newspaper"></i>
														</span>
														{strings.blog}
													</Link>
												</li>

												{setting.data &&
														setting.data.is_enable_tester > 0
														?
															<li className="nav-item">
																<Link
																	to="/tester"
																	className="nav-link"
																>
																	<span className="mobile_menu_ic">
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="24"
																			height="24"
																			viewBox="0 0 24 24"
																		>
																			<g
																				id="sale"
																				transform="translate(-72.8 -10)"
																			>
																				<path
																					id="Path_15498"
																					data-name="Path 15498"
																					d="M96.8,25.075v-7.5A3.182,3.182,0,0,0,95,14.8l-8.294-4.34a4.16,4.16,0,0,0-3.814,0L74.6,14.8a3.185,3.185,0,0,0-1.8,2.77v8.859a3.185,3.185,0,0,0,1.8,2.77l8.294,4.34a4.174,4.174,0,0,0,3.811,0l8.384-4.35-.006-.01a.584.584,0,0,0,.343-.507.648.648,0,0,0-.688-.6.73.73,0,0,0-.345.093l-.006-.007L86,32.511a2.617,2.617,0,0,1-2.4,0l-8.294-4.34a2.008,2.008,0,0,1-1.132-1.741V17.573a2,2,0,0,1,1.132-1.741l8.294-4.34a2.617,2.617,0,0,1,2.4,0l8.3,4.34a2,2,0,0,1,1.129,1.741v7.5h0a.7.7,0,0,0,1.379,0Z"
																				/>
																				<path
																					id="Path_15499"
																					data-name="Path 15499"
																					d="M237.858,202.326l-.384-1.108a.753.753,0,0,0-.823-.427l-1.477.187c-.625.08-1.072-.47-.739-.9l2.321-2.992a4.737,4.737,0,0,1-.847-5.569,6.945,6.945,0,0,1,5.541-3.363c4.207-.4,7.79,2.247,7.79,5.564a4.931,4.931,0,0,1-1.4,3.368l2.321,2.992c.336.432-.114.982-.739.9l-1.478-.187a.755.755,0,0,0-.823.427l-.384,1.108a.812.812,0,0,1-1.333.155l-2.469-3.183a7.518,7.518,0,0,1-1.279,0l-2.471,3.183A.807.807,0,0,1,237.858,202.326Zm5.817-4.318,2.1,2.706.288-.834a.758.758,0,0,1,.823-.427l1.174.148-2.036-2.623.366-.332a3.77,3.77,0,0,0,.892-4.759,5.381,5.381,0,0,0-3.922-2.5c-3.48-.531-6.532,1.622-6.532,4.337a3.961,3.961,0,0,0,1.381,2.926l.366.332L236.54,199.6l1.174-.148a.755.755,0,0,1,.823.427l.288.832,2.1-2.7.483.065a6.865,6.865,0,0,0,1.784,0Z"
																					transform="translate(-157.501 -173.678)"
																				/>
																				<path
																					id="Path_15500"
																					data-name="Path 15500"
																					d="M368.633,284.567l.209-1.217a.611.611,0,0,0-.174-.54l-.886-.861a.61.61,0,0,1,.339-1.04l1.222-.177a.608.608,0,0,0,.458-.334l.548-1.108a.609.609,0,0,1,1.093,0l.545,1.108a.617.617,0,0,0,.458.334l1.222.177a.61.61,0,0,1,.339,1.04l-.884.861a.612.612,0,0,0-.177.54l.209,1.217a.609.609,0,0,1-.884.642l-1.093-.575a.6.6,0,0,0-.568,0l-1.093.575A.608.608,0,0,1,368.633,284.567Zm1.976-1.309a.617.617,0,0,1,.568,0l.568.3-.107-.632a.615.615,0,0,1,.174-.54l.458-.448-.632-.092a.617.617,0,0,1-.461-.334l-.284-.573-.284.575a.617.617,0,0,1-.461.334l-.635.092.458.448a.612.612,0,0,1,.177.54l-.107.632Z"
																					transform="translate(-286.095 -262.4)"
																				/>
																			</g>
																		</svg>
																	</span>
																	{strings.tester}
																</Link>
															</li>
														: null}

												{setting.data &&
													setting.data.special_menu_enable
													?
													<li className="nav-item">
														<Link
															to="/special-sale"
															className="nav-link"
														>
															<span className="mobile_menu_ic">
																<svg
																	xmlns="http://www.w3.org/2000/svg"
																	width="24"
																	height="24"
																	viewBox="0 0 24 24"
																>
																	<g
																		id="special-sale"
																		transform="translate(-72.8 -10)"
																	>
																		<path
																			id="Path_15498"
																			data-name="Path 15498"
																			d="M96.8,25.075v-7.5A3.182,3.182,0,0,0,95,14.8l-8.294-4.34a4.16,4.16,0,0,0-3.814,0L74.6,14.8a3.185,3.185,0,0,0-1.8,2.77v8.859a3.185,3.185,0,0,0,1.8,2.77l8.294,4.34a4.174,4.174,0,0,0,3.811,0l8.384-4.35-.006-.01a.584.584,0,0,0,.343-.507.648.648,0,0,0-.688-.6.73.73,0,0,0-.345.093l-.006-.007L86,32.511a2.617,2.617,0,0,1-2.4,0l-8.294-4.34a2.008,2.008,0,0,1-1.132-1.741V17.573a2,2,0,0,1,1.132-1.741l8.294-4.34a2.617,2.617,0,0,1,2.4,0l8.3,4.34a2,2,0,0,1,1.129,1.741v7.5h0a.7.7,0,0,0,1.379,0Z"
																		/>
																		<path
																			id="Path_15499"
																			data-name="Path 15499"
																			d="M237.858,202.326l-.384-1.108a.753.753,0,0,0-.823-.427l-1.477.187c-.625.08-1.072-.47-.739-.9l2.321-2.992a4.737,4.737,0,0,1-.847-5.569,6.945,6.945,0,0,1,5.541-3.363c4.207-.4,7.79,2.247,7.79,5.564a4.931,4.931,0,0,1-1.4,3.368l2.321,2.992c.336.432-.114.982-.739.9l-1.478-.187a.755.755,0,0,0-.823.427l-.384,1.108a.812.812,0,0,1-1.333.155l-2.469-3.183a7.518,7.518,0,0,1-1.279,0l-2.471,3.183A.807.807,0,0,1,237.858,202.326Zm5.817-4.318,2.1,2.706.288-.834a.758.758,0,0,1,.823-.427l1.174.148-2.036-2.623.366-.332a3.77,3.77,0,0,0,.892-4.759,5.381,5.381,0,0,0-3.922-2.5c-3.48-.531-6.532,1.622-6.532,4.337a3.961,3.961,0,0,0,1.381,2.926l.366.332L236.54,199.6l1.174-.148a.755.755,0,0,1,.823.427l.288.832,2.1-2.7.483.065a6.865,6.865,0,0,0,1.784,0Z"
																			transform="translate(-157.501 -173.678)"
																		/>
																		<path
																			id="Path_15500"
																			data-name="Path 15500"
																			d="M368.633,284.567l.209-1.217a.611.611,0,0,0-.174-.54l-.886-.861a.61.61,0,0,1,.339-1.04l1.222-.177a.608.608,0,0,0,.458-.334l.548-1.108a.609.609,0,0,1,1.093,0l.545,1.108a.617.617,0,0,0,.458.334l1.222.177a.61.61,0,0,1,.339,1.04l-.884.861a.612.612,0,0,0-.177.54l.209,1.217a.609.609,0,0,1-.884.642l-1.093-.575a.6.6,0,0,0-.568,0l-1.093.575A.608.608,0,0,1,368.633,284.567Zm1.976-1.309a.617.617,0,0,1,.568,0l.568.3-.107-.632a.615.615,0,0,1,.174-.54l.458-.448-.632-.092a.617.617,0,0,1-.461-.334l-.284-.573-.284.575a.617.617,0,0,1-.461.334l-.635.092.458.448a.612.612,0,0,1,.177.54l-.107.632Z"
																			transform="translate(-286.095 -262.4)"
																		/>
																	</g>
																</svg>
															</span>
															<span className="header_badge">
																{setting.data.special_menu_text}
															</span>
														</Link>
													</li>
													: null}

												<li className="nav-item mobile_menu">
													<Link
														to="/try-samples"
														className="nav-link"
													>
														<span className="mobile_menu_ic">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="24"
																height="24"
																viewBox="0 0 24 24"
															>
																<path
																	id="Gift-Card"
																	d="M27.143,9.333H24.314a3.67,3.67,0,0,0,0-3.554A3.408,3.408,0,0,0,21.349,4H20.8A3.4,3.4,0,0,0,17.95,5.582L16,8.618,14.05,5.582A3.4,3.4,0,0,0,11.2,4h-.544A3.408,3.408,0,0,0,7.685,5.779a3.67,3.67,0,0,0,0,3.554H4.857A.873.873,0,0,0,4,10.222v4.889A.873.873,0,0,0,4.857,16h.857V27.111A.873.873,0,0,0,6.571,28H25.429a.873.873,0,0,0,.857-.889V16h.857A.873.873,0,0,0,28,15.111V10.222A.873.873,0,0,0,27.143,9.333ZM19.377,6.569A1.7,1.7,0,0,1,20.8,5.778h.544a1.74,1.74,0,0,1,1.714,1.631,1.779,1.779,0,0,1-.429,1.333,1.687,1.687,0,0,1-1.286.591H17.6ZM9.391,8.76a1.779,1.779,0,0,1-.429-1.333A1.74,1.74,0,0,1,10.677,5.8h.544a1.7,1.7,0,0,1,1.427.791L14.4,9.333H10.651a1.687,1.687,0,0,1-1.26-.573ZM5.714,11.111h9.429v3.111H5.714ZM7.429,26.222V16h7.714V26.222Zm17.143,0H16.857V16h7.714Zm1.714-12H16.857V11.111h9.429Z"
																	transform="translate(-4 -4)"
																	fill="#231f20"
																/>
															</svg>
														</span>
														{strings.trySamples}
													</Link>
												</li>
												<li className="nav-item mobile_menu">
													<Link
														to="/help"
														className="nav-link"
													>
														<span className="mobile_menu_ic">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="24"
																height="24"
																viewBox="0 0 24 24"
															>
																<g
																	id="help"
																	transform="translate(-2 -2)"
																>
																	<path
																		id="Path_15502"
																		data-name="Path 15502"
																		d="M14,2A12,12,0,1,0,26,14,12,12,0,0,0,14,2Zm0,22.286A10.286,10.286,0,1,1,24.286,14,10.286,10.286,0,0,1,14,24.286Z"
																		transform="translate(0 0)"
																	/>
																	<circle
																		id="Ellipse_564"
																		data-name="Ellipse 564"
																		cx="1.286"
																		cy="1.286"
																		r="1.286"
																		transform="translate(12.714 19.143)"
																	/>
																	<path
																		id="Path_15503"
																		data-name="Path 15503"
																		d="M16.143,8H14.857A3.849,3.849,0,0,0,11,11.857v.429h1.714v-.429a2.143,2.143,0,0,1,2.143-2.143h1.286a2.143,2.143,0,0,1,0,4.286H14.429v3.857h1.714V15.714a3.857,3.857,0,0,0,0-7.714Z"
																		transform="translate(-1.286 -0.857)"
																	/>
																</g>
															</svg>
														</span>
														{strings.help}
													</Link>
												</li>
												<li className="nav-item mobile_menu">
													<div className="header_login_cls">
														<div className="lang-switch" role="group" aria-label="Language">
															<button type="button" className={currentLang == "en" ? "active" : ""} onClick={() => changeLanguage({ target: { value: "en" } })}>EN</button>
															<button type="button" className={currentLang == "ar" ? "active" : ""} onClick={() => changeLanguage({ target: { value: "ar" } })}>ع</button>
														</div>
														<div className="select">
															<select
																onChange={
																	changeCurrency
																}
															>
																{country.data
																	? country.data.map(
																		(
																			item,
																			index
																		) => (
																			<option
																				value={
																					item.currency_difference
																				}
																				selected={
																					currentCurrency.country_code ==
																						item.country_code
																						? true
																						: false
																				}
																			>
																				{
																					item.country_code
																				}
																			</option>
																		)
																	)
																	: ""}
															</select>
														</div>
													</div>
												</li>
												<li className="nav-item mobile_menu download_app">
													<div className="download-wrap">
														<h3 className="heading-type2">
															{strings.downloadOurApp}
														</h3>
														<div className="download-store">
															<Link
																to="https://apps.apple.com/us/app/the-perfume-smell/id6446624938"
																className="nav-link"
															>
																<img
																	src={appstore}
																	alt="App Store"
																/>
															</Link>
															<Link
																to="https://play.google.com/store/apps/details?id=com.app.the_perfume_smell"
																className="nav-link"
															>
																<img
																	src={googleplay}
																	alt="Google Play"
																/>
															</Link>
														</div>
													</div>
												</li>
												<li className="nav-item mobile_menu">
													<div className="terms_privacy">
														<Link
															to="/terms-condation"
															className="nav-link"
														>
															{
																strings.termsCondations
															}
														</Link>
														<Link
															to="/privacy-policy"
															className="nav-link"
														>
															{strings.privacyPolicy}
														</Link>
													</div>
												</li>
												<li className="nav-item mobile_menu">
													<div className="copyright-cont">
														<h4>{strings.copyRight}</h4>
													</div>
												</li>
											</ul>
										</Nav>
										<div className="others-option">
											<div className="offer">
												<Link
													to="/try-samples"
													className="nav-link"
												>
													<span className="try_samples_badge">
														{strings.trySamples}
													</span>
													{/* <span className="offer_badge">
														{strings.offers}
													</span> */}
												</Link>
											</div>
											<div className="example">
												{comman.sale_start_date > 0 ? <Countdown date={Date.now() + comman.sale_start_date} renderer={renderer} className="flipdown flipdown__theme-dark" /> : ''}
												<div className="buttons"></div>
											</div>
										</div>
									</Offcanvas.Body>
								</Navbar.Offcanvas>
							</Container>
						</Navbar>
					</div>
				</div >
			</header >
			{
				comman.latestDiscount ? (
					<section className="discount-cls">
						<div className="container">
							<div className="disc-code">
								<p>
									{comman.homepageDiscountText != null && comman.homepageDiscountText != "" ? comman.homepageDiscountText : strings.getDiscounthere + " "}
									<span className="coupon-code">
										{comman.latestDiscount.code}
									</span>{" "}
									{strings.codeAndGet}
									{comman.latestDiscount.type == "flat"
										? "flat " +
										parseInt(comman.latestDiscount.flat) +
										" KWD"
										: comman.latestDiscount.percentage + "%"}
									{strings.offDiscount}
								</p>
							</div>
						</div>
					</section>
				) : null
			}
			{
				modalIsOpen ?
					<>

						{/* {user.preferred_country && user.preferred_language ? */}
						< Modal
							show={true}
							animation={true}
							size="lg"
							backdrop="static"
							keyboard={false}
							centered
						>
							<Modal.Header>
								<h5 className="modal-title text-center" id="exampleModalLabe111l">
									{strings.select_Preference}

								</h5>
								{/* <button
									type="button"
									className="btn-close"
									data-bs-dismiss="modal"
									aria-label="Close"
								>
									<img src={Imgcross} />
								</button> */}
							</Modal.Header>
							<Modal.Body>
								<div className="continue-btn review_modal">
									<ValidationForm onSubmit={setPreference} onErrorSubmit={setPreferenceErrorSubmit} ref={formRef}>
										<div className="popup-cont">
											<Row>
												<Col md="6">
													<Form.Group
														className="form-group"
														controlId="form-group"
													>
														<Form.Label>{strings.select_country}</Form.Label>

														<SelectGroup
															name="preferred_country"
															id="country"
														>

															{country.data && country.data.map((option, index) => {
																return <option key={option.id} >
																	{option.name}
																</option>
															})}

														</SelectGroup>
													</Form.Group>
												</Col>
												<Col md="6">
													<Form.Group
														className="form-group"
														controlId="form-group"
													>
														<Form.Label>{strings.choose_lang}</Form.Label>
														<SelectGroup
															name="preferred_language"
															id="language"


														>

															<option value="en">{strings.english}</option>
															<option value="ar">{strings.arabic}</option>
														</SelectGroup>
													</Form.Group>
												</Col>
											</Row>


											<div className="login-btn">
												<Button
													type="submit"
													className="btn btn_primary"
												>
													{strings.continue}
												</Button>
											</div>

										</div>
									</ValidationForm>
								</div>
							</Modal.Body>
						</Modal>
					</>
					: null
			}
			{
				activePopup && (
					<Modal
						show={true}
						centered
						onHide={() => closePopup(activePopup.id)}
					>
						<Modal.Body className="text-center p-0 position-relative">

							<button
								className="btn-close position-absolute end-0 m-2"
								onClick={() => closePopup(activePopup.id)}
							/>

							{(() => {

								if (activePopup.banner_type === 'video') {
									return (
										<video width="100%" controls>
											<source src={activePopup.file} type="video/mp4" />
											<source src={activePopup.file} type="video/ogg" />
											<source src={activePopup.file} type="video/webm" />
										</video>
									);
								}

								const imageSrc = activePopup.file || activePopup.image || activePopup.logo;

								const hasLink = !!activePopup.banner_for_id;
								let toUrl = "";

								if (hasLink) {
									toUrl = `/product/${activePopup.type !== "product"
											? activePopup.type
											: "product-detail"
										}/${activePopup.banner_for_id}`;
								}

								const picture = (
									<picture>
										<source media="(min-width:575.98px)" srcSet={imageSrc} />
										<img
											src={imageSrc}
											alt={activePopup.title || imageSrc}
											className="img-fluid w-100"
										/>
									</picture>
								);

								return (
									<div className="banner-img">
										{hasLink ? <Link to={toUrl}>{picture}</Link> : picture}
									</div>
								);

							})()}

						</Modal.Body>
					</Modal>
				)
			}

			{/* Notify-me modal — triggered from search result bell icon */}
			{notifyMeModal && (
				<Modal show={true} animation={true} size="md" backdrop="static" keyboard={false} centered>
					<Modal.Header>
						<h5 className="modal-title">{strings.notifyMe || 'Notify Me'}</h5>
						<button type="button" className="btn-close" onClick={() => setNotifyMeModal(false)} aria-label="Close">
							<img src={Imgcross} alt="Close" />
						</button>
					</Modal.Header>
					<Modal.Body>
						<div className="continue-btn review_modal notify_me_modal">
							<ValidationForm onSubmit={(e) => { e.preventDefault(); submitNotifyMe(); }}>
								<div className="popup-cont">
									<Form.Group className="form-group" controlId="notifyMeName">
										<Form.Label>{strings.name || 'Name'}</Form.Label>
										<TextInput
											name="notifyMeName"
											id="notifyMeName"
											placeholder={strings.plz_enter_name || 'Enter your name'}
											required
											value={notifyMeName}
											onChange={(e) => setNotifyMeName(e.target.value)}
										/>
									</Form.Group>
									<Form.Group className="form-group" controlId="notifyMePhone">
										<Form.Label>{strings.phoneNumber || 'Phone Number'}</Form.Label>
										<TextInput
											name="notifyMePhone"
											id="notifyMePhone"
											placeholder={strings.plz_enter_phone || 'Enter your phone'}
											required
											value={notifyMePhone}
											onChange={(e) => setNotifyMePhone(e.target.value)}
										/>
									</Form.Group>
									<div className="login-btn">
										<Button type="submit" className="btn btn_primary">
											{strings.notifyMe || 'Notify Me'}
										</Button>
									</div>
								</div>
							</ValidationForm>
						</div>
					</Modal.Body>
				</Modal>
			)}
		</>
	);
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
